/**
 * Do not edit this file!
 * These are auto-generated.
 * Last updated: Fri May 29 2026 10:23:48 GMT+0000 (Coordinated Universal Time)
 **/
export const strings = {
  "en": {
    "wordsOr": "or",
    "wordsOpen": "open",
    "wordsArticle": "Article",
    "signedInAs": "Signed in as",
    "wordsUpdateSocialSuccess": "Successfully updated social accounts",
    "wordsUpdateSocialError": "Error updating social accounts. Please try again.",
    "wordsInvalidURL": "Invalid URL",
    "wordsInvalidXURL": "Invalid X Profile URL",
    "wordsInvalidFacebookURL": "Invalid Facebook Profile URL",
    "wordsMissingXHandle": "Missing twitter(X) handle",
    "wordsMissingFacebookHandle": "Missing facebook handle",
    "wordsDetails": "Details",
    "wordsUse": "Use",
    "wordsVerified": "Verified",
    "wordsNotVerified": "Not Verified",
    "wordsTaskNotFoundDescription": "Sorry, the task you were looking for could not be found.",
    "wordsCardImage": "Card image",
    "wordsUserProfilePicture": "User Profile Picture",
    "wordsMe": "Me",
    "wordsAccount": "Account",
    "wordsComplete": "Complete",
    "wordsError": "Error",
    "wordsDisabled": "Disabled",
    "wordsCanceled": "Canceled",
    "wordsRunning": "Running",
    "wordsQueued": "Queued",
    "wordsScheduled": "Scheduled",
    "wordsImmediate": "Immediate",
    "wordsRecent": "Recent",
    "wordsCopyright": "Copyright",
    "wordsAllRightsReserved": "All rights reserved.",
    "wordsTellUsWhatYouLike": "Tell us what you liked about it...",
    "wordsTellUsWhatYouDislike": "Tell us what you disliked about it...",
    "wordsFeedbackSuccess": "Feedback Successfully submitted",
    "wordsIndustryCategory": "Industry Category",
    "wordsPleaseSelect": "Please select an option",
    "wordsProductsAndServices": "Products and Services",
    "wordsProductsAndServicesPlaceholder": "Your products and services (separate by commas)",
    "wordsCompanyOverview": "Company Overview",
    "wordsOverviewPlaceholder": "Please give a brief overview of your company...",
    "wordsAboutTitle": "Tell us more about your organization",
    "wordsAboutDescription": "Keep us up-to-date with relevant info about your organization",
    "wordsTakingTooLong": "Taking too long?",
    "wordsDeletingTask": "Deleting task",
    "wordsWelcome": "Welcome",
    "wordsRefreshing": "Refreshing",
    "wordsRegenerated": "Regenerated",
    "wordsCompanyName": "Company Name",
    "wordsCompanyNamePlaceholder": "eg. XYZ IT Services",
    "wordsSignOutDescription": "Signing out ",
    "wordsIntegrations": "Integrations",
    "wordsSystem": "System",
    "wordsAccountUsers": "Account Users ",
    "wordsAccountUsersDescription": "Manage all account users in one place. ",
    "wordsEmailPlaceholder": "Enter email ",
    "wordsNoUsers": "No Account Users",
    "wordsUserAlreadyExist": "User Already Exist",
    "wordsMaxUsers": "Max users reached",
    "wordsUserInviteSuccess": "User invited",
    "wordsUserInviteError": "User invite error",
    "wordsUserDoesNotExist": "No user found",
    "wordsNoAccount": "No account",
    "wordsViewAll": "View all",
    "wordsUserDeleteSuccess": "User deleted",
    "wordsUserDeleteFailure": "User delete error",
    "wordsUserDeleteConfirm": "Are you sure?",
    "wordsManageAccounts": "Manage accounts",
    "wordsDeletingUser": "Deleting user",
    "wordsSwitchAccount": "Switch account",
    "confirmAccountSwitch": "Are you sure you want to switch to {account}?",
    "accountSwitched": "Account switched",
    "runningSubTasks": "Running {count} sub-tasks",
    "profilePicture": "profile picture",
    "FailedLogoutMessage": "Failed to log out, please try again.",
    "logoutMessage": "Signing out of app, please wait",
    "buttonsSubmit": "Submit",
    "buttonsSubmitting": "Submitting...",
    "buttonsBackToList": "Back to task list",
    "buttonsSavingChanges": " Saving...",
    "buttonContinue": "Continue",
    "buttonsAddingUser": " Adding",
    "buttonsAddUser": " Add User",
    "buttonsAddAccount": " Add Account",
    "formsDescription": "Description",
    "formsAddURL": "Add URL",
    "formsAddContent": "Add Content",
    "formsExceededContentLimit": "Exceeded Content Limit",
    "formsWebsiteUrl": "Website Url",
    "formsHTML": "HTML",
    "formsUrl": "Url",
    "formsHTMLContent": "HTML Content",
    "formsAddTopic": "Add Topic",
    "formsTopic": "Topic",
    "formsSearchQuery": "Search Query",
    "appPageNotFound": " \"Page Not Found\"",
    "appPageNotFoundDescription": " \"Sorry",
    "appClickButtonBelowToGoHome": " \"Click the button below to go back to the home page.\"",
    "authDidntGetEmail": "Didn't get the email?",
    "authResendEmail": "Click here to send again",
    "authConfirmedEmail": "Confirmed your email?",
    "authErrorMessage": "There was an error signing you in, please try again",
    "billingExceededCreditsAvailable": "You have {creditAvailable} credits available.",
    "startFreeTrial": "Start Free Trial",
    "freeTrialTitle": "Start 14 day free trial",
    "freeTrialDescription": "Try now & decide later. No credit card required",
    "accountFreeTrialInfo": "You're currently on a free trial, upgrade for full access",
    "success": "Success",
    "scheduledFor": "Scheduled for {date}",
    "seePendingTasks": "See pending tasks",
    "pastDateError": "Date must be in the future",
    "scheduleThisTask": "Schedule This Task\"",
    "taskScheduledSuccessMessage": "Task scheduled successfully for {date}",
    "noScheduledTasks": "No scheduled content",
    "noScheduledTasksInfo": "Once you schedule a task, it will appear here. Click the button below to get started.",
    "thumbsUp": "This is good",
    "thumbsDown": "This is bad",
    "regenerate": "Regenerate",
    "following": "Following",
    "followers": "Followers",
    "posts": "Posts",
    "joined": "Joined",
    "visitWebsite": " Visit Website",
    "newTaskNewTaskDescription": "Choose a task to instantly generate personalized marketing content. From a single post to a full-scale campaign, begin here.",
    "newTaskSingleTasks": "Single Tasks",
    "newTaskRunNewTask": "Start a New Content Quest",
    "newTaskCombinedTasks": "Combined Tasks",
    "newTaskInputHeader": "Tailored to Your Input",
    "newTaskInputDescription": "Provide clear topics or URLs for precise content creation. Detailed inputs yield more targeted results.",
    "newTaskScheduleTask": "Schedule Future Tasks",
    "newTaskScheduleTaskDescription": "Set up future tasks for automated content delivery. Stay ahead with consistent, timely marketing material.",
    "newTaskTitle": "New Content Quest",
    "editTaskTitle": "Edit Task",
    "PlanYourContentStrategy": "Plan Your Strategy",
    "PlanYourContentStrategyMessage": "Stay proactive with your marketing calendar. Utilize your past task runs to inform and schedule new content.",
    "OptimizeYourContentOutput": "Optimize Your Content",
    "OptimizeYourContentOutputMessage": "Examine previous results to refine future inputs. Marketing assistant learns from past content to enhance effectiveness.",
    "SwitchtoLightMode": "Switch to Light Mode",
    "SwitchtoDarkMode": "Switch to Dark Mode",
    "IconrepresentingLightMode": "Icon representing Light Mode",
    "IconrepresentingDarkMode": "Icon representing Dark Mode",
    "TaskList": "Task List",
    "taskUpdateSuccess": "Task updated successfully",
    "timeAm": "AM",
    "timePm": "PM",
    "update": "Update",
    "linksUsed": "Links used",
    "SwitchbetweenLightandDarkMode": "Switch between Light and Dark Mode",
    "noActiveMessageText": "Select a message to view its content",
    "noMessageResponseText": "Sorry, this message has no response",
    "null": null,
    "generatedImage": "generated image",
    "CannotPasteText": "Cannot paste text, limit exceeded",
    "createdOn": "Created on",
    "errorAccountUpdate": "Error Updating User Account",
    "taskDeletedSuccessful": "task deleted",
    "confirmDeleteScheduledTaskMessage": "Do you want to delete this {task} task?",
    "FetchingAccountInfo": "Fetching Account Information...",
    "GettingSocialAccounts": "Getting Social Media Accounts...",
    "ObtainingUsageData": "Obtaining Usage Data...",
    "FetchingTaskDetails": "Fetching Task Details...",
    "infoAccountUpdated": "Account Update Success",
    "language": "Language",
    "Connected": "Connected",
    "Connecting": "Connecting",
    "Disconnected": "Disconnected",
    "SocketDisconnectTooltip": " Click to reconnect immediately",
    "confirmAccountDeletion": " Are you sure you want to delete this account?",
    "accountDeleted": " Account deleted",
    "wordsAccounts": " Accounts",
    "noAccounts": " No accounts",
    "addTenantAccountDescription": " Fill the details to add your new account",
    "acknowledgeCompanyAuthorized": " I acknowledge that I am authorized by this company",
    "settingsUsageTitle": "Usage for {currentMonthName}",
    "tenantWelcomeMessage": "Let's set up your first account",
    "createFirstAccount": "Create your first account",
    "accountListDescription": "Add and manage up to {count} accounts",
    "tenantBackToAppLink": "Back to {companyName} Marketing Assistant",
    "WordPressUsernamePlaceholder": "Enter WordPress Account username ",
    "WordPressPasswordPlaceholder": "Enter WordPress Application Password ",
    "WordPressDomainPlaceholder": "Enter WordPress URL ",
    "Password": "Password",
    "UsernameLabel": "Username",
    "userIdNotAvailble": "Primary user Id not available, please try again",
    "errorLinkingAccount": "Error connnecting account",
    "noConnection": "No connection provided",
    "errorPostingToInstagram": "Error occurred while posting to instagram",
    "requiredParameter": " {param} is required",
    "accountsLinked": "Account linked",
    "connected": "Connected",
    "connect": "Connect",
    "configure": "Configure",
    "permissionsUpdated": "Permissions updated",
    "errorUpdatingPermissions": "Error updating permissions",
    "postedInstagram": "Posted on Instagram",
    "postToInstagram": "Post to Instagram",
    "errorPostingToFacebook": "Error posting to Facebook",
    "noPageSelected": "No page selected",
    "viewFacebook": "View on Facebook",
    "postedFacebook": "Posted on Facebook",
    "postToFacebook": "Post to Facebook",
    "wordsPage": "Page",
    "AuthorizeAppLink": " here",
    "Requirements": "Requirements",
    "Instructions": "Instructions",
    "postedOn": "Posted on {date}",
    "postAgain": "Post again?",
    "posting": "Posting...",
    "AuthorizeApp": "Authorize app",
    "errorPostingToWordpress": "Error occurred while posting to WordPress",
    "viewWordpressPost": "View on Wordpress",
    "postToWordpress": "Post to WordPress",
    "wordpressLinkError": " Error connecting Wordpress account. Please check credentials",
    "accountsUnlinked": " Account connected",
    "wordpressUnlinkError": "Error connecting Wordpress account",
    "note": "Note",
    "disconnect": "Disconnect",
    "disconnectConfirmation": "Do you want to disconnect this {name} integration?",
    "errorDisconnecting": "Error occured",
    "disconnectSuccess": " {connection} disconnected",
    "WordpressNote": "Only Wordpress Admin, Editor and Author roles can post to WordPress.",
    "wordpressInstructions": "Enter your WordPress site's base URL (e.g. https://mywebsite.com). Click the link below the URL field to be redirected to the WordPress App authorization page to create an application password. Then enter your Wordpress account username and the password you just created in the respective fields. Contact your site-admin if access is unavailable.",
    "disable": "Disable",
    "wordpressLinked": "Wordpress connected",
    "wordpressUnlinked": " Wordpress disconnected",
    "postedMany": "Posted {number} times. Last on {date}",
    "connectingFacebook": "Connecting to Facebook...",
    "connectingInstagram": "Connecting to Instagram...",
    "aboutYourCompany": "Tell us about your company",
    "moreAboutYourCompany": "Tell us a little more about your company",
    "frequencyDescription": "Scheduled to run {frequency}",
    "RepeatOn": "Repeat on",
    "EndsOn": "Ends on",
    "Change": "Change",
    "schedulerDescription": "How often do you want this task to run?",
    "endDate": "Ends on {endDate}",
    "wordsOn": "On",
    "wordsOff": "Off",
    "taskCompleteNotificationTitle": "Completed Tasks",
    "taskCompleteNotificationDescription": "Be notified through email when a task finishes executing.",
    "notificationsUpdated": "Notifications Updated",
    "myNotifications": "My Notifications",
    "wordsGeneral": " General",
    "editPost": " Edit Post",
    "clearAll": "Clear All",
    "onboardingStepError": " There was an error getting the required steps. Please click the button to try again",
    "permissionsError": "Permissions error, please try again",
    "errorGettingPlans": " \"There was an error getting the plans",
    "wordsFiles": "Files",
    "wordsAbout": "About",
    "wordsSocial": "Social",
    "socialInstagram": "Instagram",
    "socialLinkedin": "Linkedin",
    "socialYoutube": "Youtube",
    "socialThreads": "Threads",
    "socialAccountDescription": "Enter your {account} account's URL",
    "notAvailable": "Not available",
    "paymentFailedTitle": "Payment failed",
    "paymentFailedDescription": "Your last payment attempt was unsuccessful. Click the manage subscription button below to manage your subscription",
    "onboardingSuccessText": "You're all set",
    "invalidSocialUrl": "Invalid {type} url",
    "formsName": "File name",
    "upload": "Upload",
    "uploadFile": "Upload File",
    "uploading": "Uploading",
    "noFilesTitle": "No files",
    "noFilesDescription": "Upload files to get started",
    "unAuthorizedError": "You are not authorized to perform this action",
    "businessPlan": "Business Plan",
    "upgradeToBusinessPlan": "Upgrade to Business plan",
    "businessPlanUpgradeSuffix": "and get up to 3 companies in one account\"",
    "whyUpgrade": "Why should you upgrade to the business plan?",
    "upgradeReasonIntro": "The business plan gives you:",
    "upgradeInfo": "You will be taken to the checkout page to complete the upgrade",
    "specifyList": "Specify List",
    "emailsFromCompany": "Emails from my company domain",
    "addToEmailList": "Add to Email List",
    "connectSuccess": "{connection} connected",
    "outgoingUrlNote": "Complete integration to see outgoing webhook URL",
    "outgoingHook": "Outgoing Webhook",
    "incomingHook": "Incoming Webhook",
    "teamsInstructions": "<p>Enter the link from Microsoft Teams in the Incoming Webhook Field.</p><p>Enter the token  form Microsoft Teams in the Token Field</p>",
    "customPlanUpgradePre": "Switch to a custom plan",
    "customPlanUpgradeSuffix": "to increase your account limit",
    "seeOptions": "See options",
    "customPlans": "Custom Plans",
    "customPlansSubtitle": "Your account limit is {limit}, you're upgrading to:",
    "maximumCustomPlansLimit": "Maximum limit for custom plans is {count}",
    "minimumCustomPlansLimit": "Minimum limit for custom plans is {count}",
    "minMaxCustomPlansLimit": "Please select a number between {min} and {max}",
    "accountsMoreThanNewLimit": "Plan limit can't be less than the number of active accounts",
    "alreadyOnPlanError": "You are already on this plan",
    "wordsActive": "Active",
    "wordsDismiss": "Dismiss",
    "wordsReload": "Reload",
    "pwaUpdateMessage": "New content available. Click the reload button to update",
    "wordsDowngrade": "Downgrade",
    "clickToCopyLink": "( Click to copy link )",
    "integrationProblem": "There was a problem with the integration. Please try again",
    "useEmailBelow": "Use the email address below to communicate with your Marketing Assistant.",
    "emailAddress": "Email Address",
    "connectedMetaSuccess": "{connection} connected, proceed to configure your Pages",
    "connectedTeamsSuccess": "Microsoft Teams connected, below is your outgoing webhook URL",
    "wordsCompetitorsTitle": "Tell us more about your organization's competitors",
    "wordsCompetitors": "Competitors",
    "wordsCompetitor": "Competitor",
    "wordsCompetitorsDescription": "Keep us up-to-date with relevant info about your organization's competitors",
    "tastResultFeedbackTitle": "How satisfied are you with the result?",
    "changeLanguage": "Change Language",
    "onboardingCompleteTitle": "Onboarding Complete",
    "requiredValidationMessage": "{field} is required",
    "greetingGoodMorning": "Good Morning",
    "greetingGoodAfternoon": "Good Afternoon",
    "greetingGoodEvening": "Good Evening",
    "howCanBotHelpToday": "How can I help you today?",
    "defaultSuggestionTitle": "What do you need help with?",
    "defaultSuggestionDescription": "Enter the details of your task and let's get started",
    "scheduleNextTask": "Schedule your next task",
    "clearSchedule": "Clear schedule",
    "processing": "Processing",
    "complete": "Complete",
    "wordsInterval": "Interval",
    "taskResultFeedbackTitle": "How satisfied are you with the result?",
    "freeTrialScheduledTaskInfo": "Upgrade your plan to gain access to scheduling features for tasks.",
    "addCompetitor": "Add Competitor",
    "editCompetitor": "Edit Competitor",
    "competitorsUpdated": "Competitors Updated",
    "newCompetitorWillBeAddedAfterVerify": "New competitor websites will appear once they have been verified.",
    "notice": "Notice",
    "reset": "Reset",
    "pagesIdentified": "{number} pages identified",
    "confirmSocialLinkDeletion": "Are you sure you want to remove this {platform} link?",
    "confirmCompetitorDeletion": "Are you sure you want to remove this competitor",
    "suggestions": "Suggestions",
    "suggestionsSubHeading": "Here are some suggestions for you",
    "noSuggestions": "No suggestions",
    "errorLoadingSuggestions": "There was an error loading your suggestions. Please try again",
    "noSuggestionsInfo": "Nothing to show yet. Helpful marketing tips tailored for {companyName} are on the way!",
    "wordCategory": "Category",
    "wordTags": "Tags",
    "wordAccept": "Accept",
    "subPages": "Sub pages",
    "lastVisited": "Last Visited",
    "preferenceSaved": "Preference Saved",
    "wordsDecline": "Decline",
    "websiteCrawlEventDescription": "Your website will be scanned for relevant content",
    "competitorWebsiteCrawlEventDescription": "Your competitors' websites will be scanned for relevant content that can be used to improve your content",
    "frequencyWithDay": "Runs {frequency} on {day}",
    "frequencyDaily": "Runs daily",
    "socialMediaCrawlEventDescription": "Your social media platforms will be scanned for relevant content.",
    "competitorSocialMediaCrawlEventDescription": "Your competitors' social media platforms will be scanned for relevant content that can be used to improve your content",
    "suggestionsSystemActivityDescription": "Your company and competitor data will be analyzed daily to bring you fresh marketing insights!",
    "noRecentConversationsTitle": "No recent conversations",
    "noRecentConversationsDescription": "Start a conversation to get started",
    "addSocialAccount": "Add Social Account",
    "accountType": "Account Type",
    "wordsDate": "Date",
    "wordsTime": "Time",
    "myCompany": "My Company",
    "websiteDetails": "Website Details",
    "noNewContent": "No new content",
    "latestContent": "Latest content",
    "systemActivities": "System Activities",
    "myActivities": "My Activities",
    "accountSocialPageTitle": "{platform} Account Details",
    "competitorSocialPageTitle": "Competitor {platform} Account Details",
    "socialPlatformPost": "{platform} Post",
    "socialPlatformPosts": "{platform} Posts",
    "noSocialPlatformPosts": "No {platform} posts",
    "socialPageNotFound": "Sorry, the profile couldn't be found. Please check back later.",
    "lastPageCrawlFailed": "Last page visit failed",
    "basicInformation": "Basic Information",
    "suggestionRatingLabel": "How would you rate this suggestion?",
    "suggestionRatingFeedback": "Thanks for your feedback! It helps us make your insights better!",
    "bad": "Bad",
    "ratePost": "Rate post",
    "usePostContent": "Use post content",
    "websiteProcessingDescription": "The page is processing. Please come back in a minute or 2 to see the results.",
    "externalLink": "External link",
    "usePageData": "Use Page Data",
    "lastAccessed": "Last Accessed",
    "anywhereToSkip": "Click anywhere to skip",
    "hello": "Hello",
    "websitePending": "The website is being verified. We will begin processing shortly",
    "later": "Later",
    "noSocialPlatformPostsDescription": "'There are no posts from the last 30 days. New posts will appear here once available.'",
    "builtWith": "Built with {platform}",
    "allPages": "All Pages",
    "retryingMessage": "Request sent. We will retry shortly",
    "missingPageDataRetry": "Missing data. Revisit page?",
    "myAssistant": "My Assistant",
    "wordsAccountUpdated": "Account Updated",
    "planAndBilling": "Plan & Billing",
    "v2InputAreaPlaceholder": "Click here to start typing",
    "comingSoon": "Coming soon",
    "socialMedia": " Social Media",
    "fineTuning": "Fine Tuning",
    "similarToYourWebsite": "Similar to your website",
    "numPages": "{number} pages",
    "addNew": "Add New",
    "noCompetitors": "No Competitors",
    "addCompetitorsDescription": "Add competitors and let's help you get an edge",
    "websiteLabel": "Website",
    "files": "Files",
    "deleteFileTitle": "Delete File",
    "fileDeleted": "File Deleted",
    "deleteConfirmationMessage": "Are you sure you want to delete {filename}",
    "noPages": "No Pages",
    "noPagesfound": "No pages found for this website",
    "discovered": "Discovered {timeAgo}",
    "postDetails": "{platform} post details",
    "notifications": "Notifications",
    "noNotifications": "No Notifications",
    "wordsPost": "Post",
    "everything": "Everything",
    "company": "Company",
    "profile": "Profile",
    "wordsAll": "All",
    "socialAccountSelect": "Select type of social account",
    "resize": "Resize",
    "reels": "Reels",
    "recentSearches": "Recent Searches",
    "foundResults": "Found {number} results",
    "mustBeUniqueCompetitor": "Must be a unique competitor ",
    "cannotUseSocialMediaUrl": "Social media URLs are not allowed. Please enter a website URL",
    "mailSubject": "Subject",
    "mailSidebarInfo": "Send task requests to your assigned email address",
    "mailResultInfo": "Once your task is created, the result will be in the response",
    "facebookReel": "Facebook Reel",
    "facebookReels": "Facebook Reels",
    "instagramReel": "Instagram Reel",
    "selectPostType": "Select post type",
    "regularPost": "Regular Post",
    "reelsPostingNote": "Reels are optimized for short-form video content and will appear in the Reels section",
    "images": "Images",
    "facebookReelDetails": "Facebook reel details",
    "profileDetails": "{platform} account details",
    "webpageDetails": "Webpage details",
    "wordsResearch": "Research",
    "wordsQuery": "Query",
    "researchDescription": "Provide a query about your company and let's research and let you know how you rank against your competitors, and your general approval rating on the internet.",
    "createFirstQuery": "Create your first query",
    "newQuery": "New query",
    "companyRank": "Company rank",
    "competitorRank": "Competitor rank",
    "favorableResults": "Favorable results",
    "wordsReason": "Reason",
    "noReasonValidationError": "At least one reason must be selected",
    "wordsPricing": "Pricing",
    "workingOnQuery": "Working on your query",
    "wordsResults": "Results",
    "appearances": "Appearances",
    "favorablePercent": "Favorable result percentage",
    "errorOccurredTryAgain": "An error occured. Please try again later.",
    "authWordsSignOutDescription": "Signing you out",
    "processingPages": "Processing pages",
    "accountWebsiteProcessed": "All pages processed for website {url}",
    "pagesCrawledDescription": "{complete} of {total} pages complete",
    "competitorWebsiteProcessed": "All pages processed for competitor website {url}",
    "accountPageProcessed": "Website page, {url}, successfully processed",
    "accountLinkedinCompanyProcessed": "Account LinkedIn company discovered",
    "competitorLinkedinCompanyProcessed": "Competitor LinkedIn company discovered",
    "accountSocialPostsProcessed": "Account {platform} posts discovered",
    "competitorSocialPostsProcessed": "Competitor {platform} posts discovered",
    "accountSocialProfileProcessed": "Account {platform} profile discovered",
    "competitorSocialProfileProcessed": "Competitor {platform} profile discovered",
    "allSocialProcessed": "All account social platforms processed",
    "allCompetitorSocialProcessed": "All competitor social platforms processed",
    "genericSocialProcessed": "Social account discovered",
    "socialPostDiscovered": "Social post discovered",
    "allDataProcessed": "Account and competitor data discovered and reviewed",
    "selectAll": "Select All",
    "singleTaskDeletionMessage": "Do you want to delete this task?",
    "bulkTaskDeletionMessage": "Do you want to delete these tasks?",
    "canAddCompetitorMessage": "To add new Competitor",
    "wordsIncoming": "Incoming",
    "wordsOutgoing": "Outgoing",
    "featureNotAvailable": "Not available in current plan",
    "CreateFacebookContent": "Create Facebook Content",
    "CreateTwitterContent": "Create Twitter Content",
    "CreateLinkedInPost": " Create LinkedIn Post",
    "ComposeEmail": "Compose Email",
    "GenerateIdeas": "Generate Ideas",
    "CreateFacebookVideoScript": " Create Facebook Video Script",
    "CreateContent": " Create Content",
    "CreateInstagramPost": " Create Instagram Post",
    "AddtextImage": "Add text, images or a URL",
    "wordsPrevious": "Previous",
    "wordsHelp": "Helpwords",
    "Disclaimer": "Disclaimer",
    "infoUpdateDisclaimer": "You can only modify your company name and website once. Are you sure you want to edit this info?",
    "regeneratingContent": "Regenerating Content",
    "updatePrompt": "Not quite what you expected? Update your prompt and try again.",
    "regenerating": " Regenerating",
    "onboardingCompleteDescription": "Here's overview of your account information",
    "socialAccounts": "Social accounts",
    "noSocialAccounts": "No social accounts",
    "findHelpTipTitle": "Find help in app",
    "findHelpTipText": "Look out for icons with a question mark (?) throughout the app. This means that you can get additional information on a topic by clicking on the icon.",
    "dragImageTipTitle": "Drag & drop images when creating a task.",
    "dragImageTipText": "When creating a task, you can drag and drop an image from your computer into the editor to add a visual representation of your task. A picture is worth a thousand words",
    "didYouKnow": "Did you know?",
    "updateAssistantTitle": "Update your data",
    "updateAssistantTipText": "You can update all the details that were provided when setting up your assistant. Look for the \"Brand Hub\" icon in the sidebar.",
    "wordsTasks": "Tasks",
    "wordsAssistant": "Assistant",
    "getStartedCreateTaskDescription": "Got an idea? Let's create a task.",
    "getStartedIntegrationsDescription": "Extend your assistant by integrating with your favorite tools.",
    "getStartedResearchDescription": "Check how your website is performing against competitors across search engines.",
    "getStartedScheduleTaskDescription": "Want to create tasks on a schedule? Let's start here.",
    "getStartedFineTuningDescription": "Adjust the behavior of the assistant to fit your needs.",
    "getStartedDescription": "Welcome to your Marketing Assistant. Here are a few actions to get you started.",
    "getStartedTodosTitle": "To-dos",
    "getStartedTodosDescription": "Let's complete your set-up with these final steps.",
    "addACompetitor": "Add a competitor",
    "addCompetitorDescription": "Add or update the list of competitor websites.",
    "addASocialAccount": "Add a social account",
    "addSocialAccountDescription": "Add or update your social accounts.",
    "likes": "Likes",
    "inputTooShort": "Input too short",
    "taskCreated": "Task created",
    "createInstantTask": "Create an instant task",
    "quickTaskFooter": "Create a new task using this result",
    "quickTaskInputTip": " ✨ Tip: You can edit the prompt to match exactly what you want to generate.",
    "competitorInfo": "Competitor information",
    "noPageSummary": "No page summary available at the moment. Please check back later",
    "latestUpdates": "Latest updates",
    "updateSummary": "Update summary",
    "postUpdatesTitle": "Post updates",
    "postUpdatesDescription": "Here are the summaries of the latest posts from your competitor's social accounts",
    "noUpdatesSinceCheck": "No new updates since the last check",
    "metrics": "Metrics",
    "metricsDescription": "How this website has been performing over the past year(compared to yours)",
    "unknownCategory": "Unknown category",
    "cost": "Cost",
    "traffic": "Traffic",
    "keywords": "Keywords",
    "keywordsAndRank": "Keywords & Rank",
    "adCopies": "Ad copies",
    "nothingToDisplay": "Nothing to display at the moment",
    "sponsored": "Sponsored",
    "profileImageQuality": "Profile images",
    "okay": "Okay",
    "great": "Great",
    "excellent": "Excellent",
    "numberOfItemsSingle": "{number} item",
    "numberOfItems": "{number} items",
    "suggestionExplanation": "Explanation✨",
    "suggestionDetails": "Suggestion details",
    "suggestionMoreDetailsTitle": "More details",
    "suggestionMoreDetailsDescription": "This suggestion affects more items. Do you want to see them or continue rating?",
    "seeDetails": "See details",
    "continueRating": "Continue rating",
    "affectedPages": "Affected Pages",
    "noAdditionalData": "No additional data",
    "visitPage": "Visit page",
    "current": "Current",
    "example": "Example",
    "noExample": "No example at this time, please come back later.",
    "postedTwitter": "Posted on Twitter",
    "errorPostingToTwitter": "Error posting to Twitter",
    "accountName": "Account Name",
    "noRepost": "Tweet Already Posted",
    "postToTwitter": "Post to Twitter",
    "postLinkedIn": "Post to LinkedIn",
    "postedLinkedIn": "Posted to LinkedIn",
    "alreadyPosted": "Already Posted",
    "errorPostingToLinkedIn": "Error posting to LinkedIn",
    "header": "Header",
    "comparePlans": "Compare",
    "comparePlanLimits": "Current Plan Limits",
    "planFeatures": "Plan Features",
    "plan": "Plan",
    "business": "Business",
    "premium": "AI Suite - Agency",
    "starter": "Starter",
    "availableIntegrations": "Available integrations",
    "taskScheduling": "Task Scheduling",
    "maxCompetitors": "Maximum competitors",
    "availableResearchQueries": "Available research queries",
    "maxSocialAccounts": "Maximum social accounts",
    "numberOfUsers": "Number of users",
    "socialVisitFrequency": "Frequency of social account visits",
    "websiteVisitFrequency": "Frequency of webpage visits",
    "competitorWebsiteVisitFrequency": "Frequency of competitor account visits",
    "billingPageDescription": "Get information about your plan, features and usage.",
    "authUrlError": "Failed to get authentication URL",
    "codeStateError": "OAuth connection failed - missing code or state",
    "twitterConnectionError": "Twitter connection failed",
    "type": "Type",
    "contacts": "Contacts",
    "contactSaved": "Contact saved",
    "addContact": "Add Contact",
    "newContact": "New Contact",
    "contactDeletionConfirmation": "Are you sure you want to delete {contact}?",
    "contactDeleted": "Contact deleted",
    "newContactDescription": "Add a new contact to your account",
    "contactSubHeading": "Add, update and manage your email contacts",
    "contactEmptyStateText": "Select a contact to view or update their details",
    "templates": "Templates",
    "templateEmptyStateText": "Select a template to preview or set as default",
    "contactsUploaded": "Contacts uploaded and processing",
    "unsupportedFileFormat": "Unsupported file format",
    "logoUploaded": "Logo uploaded",
    "emailSent": "Email sent",
    "emailNotSent": "Failed to send email, please try again",
    "created": "Created",
    "status": "Status",
    "canceled": "Canceled",
    "failed": "Failed",
    "content": "Content",
    "noNewTransaction": "No new transaction foundresearchTourStep1Description",
    "popupClose": "popup Close",
    "noAccountInfo": "No account info",
    "inbox": "Inbox",
    "template1Name": "New York",
    "template2Name": "Hawaii",
    "template1Description": "Give your emails a personality",
    "template2Description": "Simple template with centered content",
    "emailSetupCompleteDescription": "You can start using the app to send marketing emails to your contacts.",
    "newMail": "New Mail",
    "tryMarketingFeature": "Try the all new email marketing feature",
    "send": "Send",
    "message": "Message",
    "bulkUpload": "Bulk Upload",
    "recipient": "Recipient",
    "setUpEmailAlias": "Setup your alias",
    "setUpEmailAliasDescription": "This is the address through which customers will receive your emails",
    "addFirstContact": "Add your first contact",
    "contactAddedToACcount": "Contact has been added to your account",
    "dropCsvFile": "Drop your csv file here",
    "addSingleContact": "Add a single contact",
    "yourEmail": "Your email",
    "yourEmailPlaceholder": "enter your email",
    "recipientEmailPlaceholder": "enter the recipient email",
    "emailSetupCustomDescription": "use your own email address to send messages to your customers",
    "emailSetupVerificationDescription": "Verification email sent. Check your mail and click the link in the email to verify. When done, come back and click the “Continue” button below.",
    "emailSetupIntroTitle": "Let's get you set up",
    "emailSetupIntroDescription": "You can use your own marketing email or go with the simple option and use a marketingassistant email. Click continue when you're ready.",
    "emailSetupTypeTitle": "Setup type",
    "emailSetupTypeDescription": "How would you want the emails to be sent with your own domain or marketingassistant.com",
    "wordSimple": "Simple",
    "wordCustom": "Custom",
    "emailSetupSimpleDescription": "add an alias and send emails using your_alias@marketingassistant.com",
    "sendTestEmailTitle": "Send a test email",
    "sendTestEmailDescription": "Let's test your new email integration. Enter an email address (different from the one you've configured) to send a test mail.",
    "skip": "Skip",
    "selectFile": "Select file",
    "activeTemplateDescription": "Your emails will look like this template when sent",
    "useTemplate": "Use template",
    "changeLogo": "Change logo",
    "selectLogo": "Select logo",
    "dropLogo": "Drop your logo here",
    "activeTemplateConfirmation": "are you sure you want to set {activeTemplateName} as the default template?",
    "templateListDescription": "Choose how your outgoing emails look and feel",
    "emailMarketingModalTitle": "Introducing Email Outreach",
    "emailMarketingModalDescription": "Reach out to your customers from right here in Marketing Assistant",
    "emailMarketingModalFeature1": "Use a marketingassistant.com alias or your own custom email",
    "emailMarketingModalFeature2": "Add and manage contacts (we support bulk uploads)",
    "emailMarketingModalFeature3": "Choose a template that fits your style",
    "emailMarketingModalFeature4": "Customize emails with your logo",
    "emailMarketingModalSubText": "And many more features coming soon!",
    "new": "New",
    "researchTourStep2Description": "Enter your query and select your reasons",
    "taskTourStep1Title": "Create Your First Task",
    "taskTourStep1Description": "Begin your path to streamlined marketing with Marketing Assistant. Simplify your efforts, save time, and create with ease. Ready to take the first step?",
    "taskTourStep2Title": "Choose Your Marketing Focus",
    "taskTourStep2Description": "Select a task category to tailor Marketing Assistant to your specific needs.",
    "taskTourStep2SubDescription": "Select a category below.",
    "taskTourStep3Title": "Select Your Task",
    "taskTourStep3Description": "Zero in on what matters most for your marketing efforts today. Marketing Assistant simplifies your marketing without sacrificing results. Let's get to work.",
    "taskTourStep4Title": "'Let’s Start Creating!'",
    "taskTourStep4Description": "You're one step closer to reclaiming your schedule with Marketing Assistant's time-saving magic.",
    "taskTourTips": "Tips to get the most from your results:",
    "detailMatters": "Detail Mattters",
    "detailMattersDescription": "The more precise your input,the more tailored your output.",
    "planAhead": "Plan Ahead",
    "planAheadDescription": "Schedule tasks and have results delivered straight to your inbox.",
    "refineRepeatDescription": "Each task helps Marketing Assistant learn and adapt to your needs for continually improved results.",
    "streamline": "Streamline",
    "streamlineDescription": "Combine different tasks for a seamless marketing strategy that works effectively in the background.",
    "integrationTourStep1Title": "Extend your assistant by integrating with your favorite tools",
    "integrationTourSep1SubTitle": "Social Media Integration",
    "integrationTourStep1Description": "Post directly to Facebook and Instagram",
    "tourContinue": "Click on the continue to setup your integration",
    "sendNow": "Send Now",
    "sendLater": "Send Later",
    "dateAndTime": "Date and Time",
    "invalidScheduleTime": "Invalid schedule time",
    "emailScheduled": "Email scheduled. It will be sent at the scheduled timeadd",
    "addGoal": "Add Goal",
    "companyGoal": "Company Goal",
    "companyGoals": "Company Goals",
    "addObjectives": "Add Objective",
    "strategicObjectives": "Strategic Objectives",
    "strategicObjective": "Strategic Objective",
    "coreMarketingChannels": "Core Marketing Channels",
    "coreMarketingChannel": "Core Marketing Channel",
    "addChannel": " Channel",
    "culturalConsiderations": "Cultural Considerations",
    "culturalConsideration": "Cultural Consideration",
    "addCulturalConsiderations": "Add Consideration",
    "customerPainPoints": "Customer Pain Points",
    "customerPainPoint": "customer Pain Point",
    "addPoint": "Add Point",
    "industryCategory": "Industry Category",
    "geographicLocation": "Geographic Location",
    "productsAndService": "Products And Service",
    "visionAndMission": "Vision And Mission",
    "vision": "Vision Statement",
    "mission": "Mission Statement",
    "brandPositioning": "Brand Positioning",
    "politicalAffiliation": "Political Affiliation",
    "politicalNonAffiliation": "Political Non Affiliation",
    "callToActions": "Call to Actions",
    "addCallToAction": "Add Call to Action",
    "maxCallToActionsReached": "Maximum of {max} call to actions allowed",
    "noCallToActions": " No call to actions available",
    "hashtagGroups": "Hashtag Groups",
    "hashtagGroupsDescription": "Organize your hashtags into groups for easy reuse",
    "hashtagGroupNamePlaceholder": "e.g. Brand, Product, Campaign",
    "addHashtagGroup": "Add Hashtag Group",
    "noHashtagGroups": "No hashtag groups available",
    "hashtagPlaceholder": "Enter a hashtag",
    "hashtagHint": "Press Enter to add each hashtag",
    "listInputHint": "Press Enter to add each item",
    "wordsHashtags": "Hashtags",
    "wordsGroup": "Group",
    "brandIdentityTone": "Brand Identity Tone",
    "brandIdentity": "Brand Identity",
    "selectTone": "Select Tone",
    "targetAudienceOverview": "Target Audience Overview",
    "targetAudience": "Target Audience",
    "targetAudienceDemographics": "Target Audience Demographics",
    "gender": "Gender",
    "education": "Education",
    "selectGender": "Select Gender",
    "ageFloor": "Age Floor",
    "ageCeiling": "Age Ceiling",
    "incomeFloor": "Mininum Income",
    "incomeCeiling": "Maximum Income",
    "processingLogo": "Processing new logo",
    "processingContacts": " Processing new contacts",
    "sendingEmail": "Processing email",
    "sendingEmails": "Processing emails",
    "sendingEmailAllContacts": "Sending email to all contacts",
    "campaigns": "Campaigns",
    "campaign": "Campaign",
    "companyDetails": "Company Details",
    "campaignDetails": "Campaign Details",
    "editCampaign": "Edit Campaign",
    "upToDate": "Already up to date",
    "playful": "Playful",
    "neutral": "Neutral",
    "serious": "Serious",
    "wordDefault": "Default",
    "createCampaign": "Create Campaign",
    "noCampaigns": "No Campaigns",
    "noCampaignsDescription": "This account has no campaigns yet.",
    "addFilter": "Add a Filter",
    "addField": "Add a Field",
    "campaignSaved": "Campaign saved",
    "campaignSaveFailed": "Failed to save campaign",
    "addFilterAlert": "Please add at least one filter",
    "nameOfCampaign": "Name of the Campaign",
    "campaignNamePlaceholder": "Enter the name of the campaign",
    "accountDataPointDescription": "This section allows you to configure the core data points that fuel our content generation engine. The more information you provide, the more accurate and relevant the content is to your brand.",
    "chooseTargetAudience": "Choose the target audience",
    "deleteCampaignConfirmation": "Are you sure you want to delete this campaign?",
    "campaignDeleteFailed": "Failed to delete campaign",
    "campaignDeleteSuccess": "Campaign deleted",
    "campaignDeleteTitle": "Delete Campaign",
    "shareComingSoon": "Coming Soon",
    "social-media/wordpress/post-to-wordpress": "Post to WordPress",
    "social-media/facebook/post-to-facebook": "Post to Facebook",
    "social-media/facebook/announce-event": "Announce Event on Facebook",
    "social-media/instagram/post-to-instagram": "Post to Instagram",
    "social-media/twitter/post-to-twitter": "Post to Twitter",
    "social-media/linkedin/post-to-linkedin": "Post to LinkedIn",
    "contentScheduled": "Content scheduled successfully",
    "contentScheduleFailed": "Content scheduling failed",
    "unsupportedContentType": "Unsupported content type",
    "selectedContentNotFound": "Selected content not found",
    "whenShouldItBePosted": "When should it be posted?",
    "noContentSelected": "No content selected. Please select an option from the list to schedule.",
    "scheduleContent": "Schedule Content",
    "scheduledContent": "Scheduled Content",
    "schedulePlatformPost": "Schedule {platform} Post",
    "removeEvent": "Unschedule",
    "eventRemoved": "Event removed successfully",
    "eventRemoveFailed": "Failed to remove event",
    "removeEventDescription": "The content will be removed from the calendar and will not be posted. Are you sure you want to continue?",
    "clickEventInstruction": "Click the event to see more details.",
    "library": "Library",
    "generate": "Generate",
    "insert": "Insert",
    "noContent": "No content",
    "noContentAvailableForCategory": "No content available for the selected category",
    "noContentPreview": "No content preview available yet",
    "noEventsForDay": "No events for this day",
    "noEventsDescription": "Sorry, there are scheduled events for this date. You can use the button below to schedule a new one",
    "createNewContentSelectTypeTitle": "What type of post do you want to schedule?",
    "featureComingSoon": "This feature is coming soon",
    "projectName": "Project Name",
    "noProject": "No Project Found",
    "emailConfigure": "Configure your email address",
    "emailStep1": "Select Me to allow sending emails from the logged-in user's email",
    "emailStep2": "Choose Email from my company domain to permit all emails from your company domain",
    "emailStep3": "Select Specify List to list the allowed email addresses",
    "emailNote": "'Once the connection is successful",
    "facebookNote": "'You must have Facebook Business/Professional account to connect'",
    "facebookStep1": "Authorize Marketing Assistant to your facebook profession account",
    "facebookStep2": "Select your Facebook Business Portfolio",
    "facebookStep3": "Select your Facebook pages you want to connect",
    "facebookStep4": "Review the permissions required and then click save",
    "facebookStep5": "'Click the Got it button to complete the connection'",
    "instagramNote": "You must have an Instagram Business/Professional account to connect",
    "instagramStep": "'Clicking continue will bring an Instagram auth popup for account login",
    "linkedInStep": "'Clicking continue will open a LinkedIn authentication popup for account login",
    "incomingHookTitle": "Configure Incoming Webhook",
    "incomingHookDesc": "'In your target Teams channel",
    "outgoingHookTitle": " Configure Outgoing Webhook",
    "outgoingHookDesc": "'Go to Manage Teams",
    "testIntegration": "Test Integration",
    "testNote": "'In the same channel",
    "thinking": "Thinking",
    "noContentForStep": "No content for this step",
    "generating": "Generating",
    "socialMediaPosts": "Social Media Posts",
    "cancelSubscription": "Cancel Subscription",
    "cancelSubscriptionDescription": "You will be taken to your portal on our secure payment provider's platform to cancel your subscription.",
    "cancelSubscriptionInstructionTitle": "Cancellation instruction",
    "cancelSubscriptionInstructionDescription": "On your payment portal, click the 'Cancel Subscription' button next to your active subscription to finalize your cancellation.",
    "closeInstructions": "Close instructions",
    "moreInfo": "More information",
    "contentUpdated": "Content updated",
    "contentUpdateFailed": "Content update failed, please try again",
    "imageLibraryLoadError": "There was an error getting images from the library, please try again",
    "noImagesInLibrary": "No images in the library",
    "imageLibraryEmptyStateText": "Upload images to the library to use them across the app.",
    "goToImgLibrary": "Go to image library",
    "noPreview": "No preview available",
    "fileDetails": "File details",
    "modified": "Modified",
    "size": "Size",
    "filesAndAssets": "Files and assets",
    "fileType": "File type",
    "editFile": "Edit file",
    "brandAndStrategy": "Brand & strategy",
    "productInformation": "Product Information",
    "mediaAssets": "Media Assets",
    "competitorResearch": "Competitor Research",
    "logo": "Logo",
    "processingFile": "Processing 1 file",
    "processingFiles": "Processing {number} files",
    "contentNotEditable": "Sorry, this content is not editable",
    "missingIntegrationTitle": "Missing integration",
    "missingIntegrationDescription": "The integration for {platform} is either disabled or misconfigured. Click the button below to check the integration.",
    "checkIntegration": "Check integrationtermsAccepted",
    "selectIntegrationAccountError": "Please select an account to continue",
    "termAndCondition": "Terms and Conditions ",
    "termsAndConditionSubtitle": "Please review and accept our terms before using Marketing Assistant",
    "termsAndConditionDescription": "By using this application, you agree to abide by our terms and conditions. For further details, please review our full Terms of Service.",
    "termsAndConditionLink": "Read our full Terms of Service",
    "termsAndConditionCheck": "I agree to the terms and conditions",
    "selectIndustryCategory": "Select Industry Category",
    "industryCaution": "Caution for Finance and Healthcare",
    "industryCautionNote1": "Users please be advised that Marketing Assistant is not HIPAA-compliant and should not be used for storing or processing sensitive financial or health-related data. If you are in the healthcare or financial services industry, we recommend reviewing our ",
    "industryCautionNote2": "to ensure our services meet your needs. By proceeding, you agree to our Terms and Conditions and acknowledge the use of Marketing Assistant for non-sensitive business data.",
    "industryCategoryAcknowledged": "I have read and accept the Terms and Conditions and Privacy Policy and acknowledge the cautions for finance and healthcare industries set forth in Section 3 of the Terms and Conditions and Section 5 of the Privacy Policy. I further represent and warrant to Marketing Assistant that",
    "industryCautionCheck": "I am not engaged in either of these industries",
    "export": "Export",
    "contentCalendarExportInstruction": "Select the start and end dates of the content to export",
    "contentExportDownloadInstruction": "Your export is ready. Use the button below to download",
    "userSharedPost": "{user} shared a post",
    "allFiles": "All files",
    "contentScheduledTitle": "Content Scheduled",
    "scheduledContentDescription": "This content has been scheduled for posting.",
    "openCalendar": "Open Calendar",
    "selectAccount": "Select Account",
    "generated": "Generated",
    "smartTips": "Smart Tips",
    "calendar": "Calendar",
    "seeMyContent": "See My Content",
    "nextUp": "Next UP",
    " nextStep": "Next Step",
    "newOnboardingComplete": "Congrats! You've Completed Onboarding!",
    "newOnboardingCompleteDesc": "Welcome to your new content HQ. You've just taken a huge step toward smarter, faster marketing and we're so excited to be part of your journey!",
    "letGetWritingTitle": "Let's get writing. Your first month of content is being served up now:",
    "seoWrite": "4 SEO-optimized blogs",
    "socialMediaWrite": "Social media posts tailored to your brand",
    "allReadyReview": "All ready to review",
    "magicalPower": "Ready to see the Magical POWER of Marketing Assistant?",
    "onboardingWelcome": "Welcome to Marketing Assistant!",
    "onboardingWelcomeDesc": "You're officially on board for a revolutionary content journey—where your personal Marketing Assistant becomes your secret weapon for smarter, faster marketing.",
    "readyToSaveTime": "Ready to save hours of time?",
    "readyToLevelUp": "Ready to level up your content game?",
    "readyToMarket": "Ready to market smarter—not harder?",
    "letsGo": "Now's the time to turn your big ideas into powerful, on-brand content—without the stress. You bring the vision, we bring the AI. Let's go!",
    "fromBlogsAndSocial": "From blogs and social posts to proactive website tips and competitive insights, you're about to do the work of four marketing tools in one powerful platform.",
    "letsRevolutionize": " Let's revolutionize your marketing—starting now.",
    "psNote": "P.S. In just 2 minutes, you'll have a full month's worth of content—SEO-optimized, tailored to your brand, and built to perform.",
    "readyToStart": "Ready to start!",
    "shareDesc": "Share a quick description that includes",
    "whoAreYou": "Who you are",
    "whatYouDo": "What you do",
    "whenYouStart": "When you started",
    "whereAt": "Where you're based",
    "missionGuideNote": "Skip this step and then check out our Mission and Vision Guide on the Smart tip page to create your own.",
    "competitiveAnalysisNote": "Check out our guide on Competitive Analysis on the Smart tip page",
    "popupsBlockedError": "Popup blocked by the browser, please check your settings and retry",
    "brandHub": "Brand Hub",
    "errorLoadingContent": "Error loading content",
    "goToOriginalContent": "Go to original content",
    "planUnavailableTitle": "Plan Unavailable",
    "planUnavailableDescription": "There have been changes to the available plans. Please check the billing page and upgrade your subscription to a new plan.",
    "planUnavailableAction": "Check Plan",
    "all": "All",
    "months3": " 3 Months",
    "months6": "6 Months",
    "webhookInstructions": "Learn more on how to Configure Incoming and Outgoing Webhook here",
    "noScheduledContent": "No Scheduled Content Found",
    "noScheduledContentDescription": "Looks like nothing has been scheduled yet. Create new content or check your filters.",
    "welcomeDescription": "Welcome to your personalized performance dashboard-powered by Al and built to help you grow.",
    "ongoingProcess": "Ongoing Processes",
    "oneMonthContent": "content for the next 1 month",
    "writeArticle": "Writing articles",
    "taskProgressStatus": "{done} of {total} done",
    "more": "More",
    "smartTipsQA": "Q&A Smart Tips",
    "gettingReady": "Getting Ready",
    "creatingContent": "Your content is being created",
    "contentCreated": "Your content has been created",
    "contentProgress": "Checking your content generation status",
    "generatingMonthContent": "Generating a month's worth of <b>personalized</b>, <b>high quality</b> content",
    "generatedMonthContent": "Generated a month's worth of <b>personalized</b>, <b>high quality</b> content",
    "tips": "Tips",
    "youAreSet": "You're all set!",
    "goHomeDescription": "You can go home while your content is generating in the background.",
    "goHome": "Go Home",
    "categories": "Categories",
    "helpfulTips": "Helpful Tips",
    "advanceTips": "Advanced Tips",
    "frozenTips": "If your Marketing Assistant dashboard seems frozen, scroll to the bottom of the screen and check the version number.",
    "havingTrouble": "Still having trouble?",
    "submitTicket": "Submit a support ticket here",
    "teamHelp": "and our team will help you out ASAP.",
    "generatingContent": "Generating content",
    "versionStatusRedIcon": "If you see a <strong>red icon</strong>, try refreshing your browser — this usually resolves the issue.",
    "versionStatusGreenIcon": "If the icon is <strong>green</strong>, you're on the latest version.",
    "researchAndCraft": "Research & Craft Your Perfect Articles",
    "featuredContent": "Featured Content Creator",
    "createMonth": "Create a month's worth of content in just a few minutes",
    "noContentFound": "Could not find the content at this time, please try again later.",
    "contentList": "Content List",
    "newContent": "New content",
    "selectContent": "Select Content",
    "contentType": " Content Type",
    "existingContent": "Existing Content",
    "integrationAvailable": "integration available",
    "missingIntegration": "Missing integration",
    "today": "Today",
    "checkOut": " Check out our Mission and Vision Guide on",
    "toCreate": "to create your own.",
    "checkOurGuide": "Check out our",
    "guideOn": "guide on Competitive Analysis",
    "createAndScheduleDesc": "Create and schedule some content and find them here",
    "startATour": "Start a tour",
    "websiteTraffic": "Website Traffic",
    "adTraffic": "Ad Traffic",
    "organicTraffic": "Organic Traffic",
    "organicCost": "Organic Cost",
    "integrations": "Integrations",
    "reschedule": "Reschedule",
    "rescheduleContent": "Reschedule Content",
    "rescheduleContentDescription": "Select a new date and time for the content to be posted",
    "accountNotFound": "Account not found",
    "accountNotFoundDescription": "The account you're looking for doesn't exist or may have been removed. Please check the username and try again.",
    "contentExportTypeDescription": " Do you want to export scheduled or general content?",
    "contentExportPlatformDescription": " Which platform do you want to export to?",
    "contentExportSocialPlatformDescription": "Which type of content do you want to export?",
    "acceptNewContent": "Accept New Content",
    "rejectNewContent": "Reject New Content",
    "setupRequired": "Setup Required",
    "setupRequiredMessage": "Your account is missing critical information. Please complete setup to continue",
    "completeSetup": "Complete Setup",
    "errorBoundaryDescription": "Please check your internet connection or try reloading the page.",
    "genericResourceRenderError": "Sorry, your {resource} could not be loaded at this time, please check your internet connection or try reloading the page",
    "singleTaskCrashError": "There's been a problem with this content, please check your internet, reload your browser, or try again with a different prompt.",
    "accountStatistics": "Account Statistics",
    "personal": "Personal",
    "organizations": "Organizations",
    "linkedInReconnect": "New: You can now post to LinkedIn organizations. To enable this, please disconnect and reconnect your LinkedIn integration.",
    "perAccount": "{count} per account",
    "enterAtLeastOneCallToAction": "Enter at least one call to action",
    "selectAtLeastOneAccountForPost": "You need to select at least one account for this post",
    "addFromLibrary": "Add a file from my library",
    "taskAttachmentDragDrop": "You can also drag and drop an image in JPG, PNG, or WEBP format inside the input box.",
    "wordpressWebsiteUrl": "WordPress Website URL",
    "continueToAuthz": "Continue to Authorization",
    "authorizeApp": "Authorize Application",
    "wpAuthzGuide": "A new tab will open where you can:|Log in to your WordPress admin panel|Review and approve the application|Copy the generated application password",
    "openAuthzPage": "Open Authorization Page",
    "doneWithAuthz": "I've completed authorization",
    "enterCredentials": "Enter Your Credentials",
    "maxImagesReached": "Maximum of {max} images allowed for {platform}",
    "removeImageToAddMore": "Remove an image to save post content",
    "maxVideosReached": "Maximum of {max} videos allowed for {platform}",
    "removeVideoToAddMore": "Remove a video to save post content",
    "maxMediaReached": "Maximum of {maxImages} images and {maxVideos} videos allowed for {platform}",
    "removeMediaToAddMore": "Remove an image or video to save post content",
    "scheduleContentPublishedTitle": "Know When Your Posts Go Live",
    "scheduledContentPublishedDescription": "Get email notifications when your scheduled posts go live.",
    "competitorReport": " Weekly Competitor Insights",
    "competitorReportDescription": "Receive weekly emails with reports on your competitors’ SEO and social media activity.",
    "viewFullImage": "View Full Image",
    "noImagePreviewTitle": "No Image Preview Available",
    "noImagePreviewDescription": "The image preview is not available at the moment. This could be due to an issue with the source website or the image may no longer be accessible.",
    "activity": "Activity",
    "noActivity": "No activity",
    "noPostsWeek": "No posts this past week",
    "postsThisWeek": "{count} posts this past week",
    "totalPosts": "{count} total posts",
    "platforms": "{count} platforms",
    "contentPostedTitle": "Content Posted",
    "taskContentPostedSuccess": "Your content has been posted successfully.",
    "taskContentScheduledSuccess": "Your content has been scheduled and will be posted at the specified time.",
    "postCompleteConfirmation": "Do you want create another post or return to the post?",
    "createNewContent": "Create New Content",
    "returnToContent": "Return to Content",
    "taskNoContent": "No content found for the selected task.",
    "confirmResetContentGeneration": "Reset and create new content?",
    "contentFilterPlaceholder": "Find the content you want to generate",
    "workingOnContent": "Working on your content",
    "contentAlmostReady": "Your content is almost ready",
    "contentReady": "Your content is ready",
    "quickTaskActionDescription": "Use one of the actions to edit, share it now or later. or create more content",
    "addMedia": "Add media",
    "quickActions": "Quick Actions",
    "postNow": "Post Now",
    "postLater": "Post Later",
    "v2ChatInstruction": "Type something to get started",
    "openApp": "Open App",
    "openChat": "Open Chat",
    "startNewConversation": "Start new conversation",
    "scheduledAndPostedAt": "Scheduled for {scheduleTime} and posted at {postTime}",
    "customLoaderText1": "Getting your data",
    "customLoaderText2": "Authenticating your request",
    "customLoaderText3": "Securing the response",
    "customLoaderText4": "Almost there",
    "crawlErrorTitle": "There was a problem with the page",
    "crawlErrorDescription": "We couldn't retrieve the data for this page. This might be due to a network issue, or the page may no longer be available.",
    "crawlTitle": "Getting page data",
    "crawlDescription": "We are working on your page please come back in a few minutes.",
    "invalidUrlTitle": "The URL provided is invalid",
    "invalidUrlDescription": "The url for this page is invalid. Please check and try again",
    "needHelp": "Need help?",
    "errorSuggestionHeading": "If this issue persists, here are some things you can try",
    "errorSuggestion1": "Verify your internet connection is stable",
    "errorSuggestion2": "Check if the URL is correct and accessible",
    "errorSuggestion3": "Try again in a few minutes",
    "errorSuggestion4": "Contact support if the problem continues",
    "uploadMedia": " Upload Media",
    "selectVideo": " Select Video",
    "videoPreview": " Video Preview",
    "videoTooLarge": " Video file is too large (max {max}MB)",
    "videoFormatNotSupported": " Video format not supported",
    "processingVideo": " Processing video...",
    "dragAndDropVideo": " Drag and drop your video here",
    "mixedMediaTitle": " Mixed Media Limitation",
    "mixedMediaWarning": " \"Most social media platforms don't support posting both images and videos together. You'll need to remove either images or videos before posting to Facebook",
    "configureIntegration": "Configure Integration",
    "manageIntegration": "Manage Integration",
    "integrationInProgress": "Integration already in progress for {platform}",
    "continueIntegration": "Continue Integration",
    "unsupportedPlatformError": "Unsupported platform: {platform}",
    "integrationError": "Failed to integrate with the selected platform. Please try again.",
    "existingIntegrationDetected": "Existing {platform} Integration Detected",
    "confirmIntegration": "Integrate {platform} Account",
    "existingIntegrationMessage": "You already have a {platform} integration connected. Before continuing, make sure you're signed into the {platform} account that matches this social URL. If you need to switch accounts, please sign out first. Your posts will be published to the newly connected {platform} account.",
    "newIntegrationMessage": "When you continue, we'll connect whichever {platform} account you're currently signed into in your browser. This connected account will be used when you select it to publish your posts. To ensure we connect the correct account, check that you're signed into the {platform} account that matches this social URL. If you're signed into a different account, please sign out before continuing.",
    "whatsNew": "What's New",
    "whatsNewSubtitle": " Latest updates and improvements to our platform",
    "loadingWhatsNew1": " Loading updates",
    "loadingWhatsNew2": " Fetching latest features",
    "loadingWhatsNew3": " Preparing content",
    "noUpdateTitle": " No updates available",
    "noUpdateDescription": "Check back soon for the latest features and improvements to our platform",
    "refresh": " Refresh",
    "moreDetails": " More Details",
    "removeImageTitle": "Remove Image",
    "removeImageDescription": "Are you sure you want to remove this attachment?",
    "maximize": "Maximize",
    "chatbotName": "My Super Agent",
    "myRecentContent": "My recent content",
    "retry": " Retry",
    "loadingError": " Some details could not be loaded. Please try again",
    "mfaSecurity": " Security",
    "multiFactorAuthentication": " Multi-Factor Authentication",
    "enableMfa": " Enable Multi-Factor Authentication",
    "mfaDescription": "Add an extra layer of security to your account with multi-factor authentication.",
    "mfaRedirectingToSetup": " You'll be redirected to complete your MFA setup",
    "mfaDisabled": " Multi-factor authentication disabled",
    "scheduledContentMissingIntegrationMessage": " This content will not be posted because there is no active integration or it has been disabled. Click the event to reconfigure the integration.",
    "missingIntegrationAlertMessage": "There is no integration for this platform or the integration has been disabled",
    "maxFilesExceeded": "You can upload a maximum of {max} files at a time",
    "runsOnceOn": "Runs once on {time}",
    "runsEvently": "Runs every {interval}",
    "sortBy": "Sort by",
    "fileSortByName": "Name",
    "newestFirst": "Newest First",
    "oldestFirst": "Oldest First",
    "words": {
      "credits": [
        "no credits",
        "credit",
        "{count} credits"
      ],
      "task": [
        "no tasks",
        "task",
        "{count} tasks"
      ],
      "copied": "Copied",
      "noResult": "No result",
      "noContent": "No content",
      "preview": "Preview",
      "noPost": "No post",
      "taskNotFound": "Task Not found",
      "topics": "Topics",
      "articles": "Articles",
      "titleTags": "Title Tags",
      "metaDescriptions": "Meta Descriptions",
      "initialResearch": "Initial Research",
      "notes": "Notes",
      "noNotes": "No notes",
      "reviewWebPage": "Review webpage",
      "home": "home",
      "noSocialPost": "No social posts",
      "person": "Person",
      "Upgrade": "Upgrade",
      "subTask": "Subtask",
      "source": "Source",
      "me": "Me",
      "token": "Token"
    },
    "buttons": {
      "cancel": "Cancel",
      "close": "Close",
      "create": "Create",
      "delete": "Delete",
      "edit": "Edit",
      "loadMore": "Load more",
      "next": "Next",
      "save": "Save",
      "add": "Add",
      "preferredLanguage": "Preferred language",
      "select": "Select",
      "back": "Back",
      "postTweet": "Post Tweet",
      "createTask": "Start a Quest",
      "cancelTask": "Cancel Task",
      "getStarted": "Get Started",
      "saveChanges": "Save changes",
      "download": "Download",
      "copy": "Copy",
      "copied": "Copied",
      "chat": "Chat"
    },
    "forms": {
      "description": "description",
      "url": "url",
      "content": "content",
      "addUrl": "add url",
      "addContent": "add content",
      "addDescription": "add description"
    },
    "settings": {
      "usage": "Usage",
      "settings": "Settings",
      "myAccount": "My account",
      "accountSettings": "Account Settings",
      "accountInformation": "Account information",
      "billingInformation": "Billing information",
      "billingInformationDescription": "Follow the link below to visit your secure billing portal. You can manage your current plan and payment method on the portal.",
      "giveFeedback": "Give feedback",
      "manageSubscription": "Manage subscription",
      "openingBillingPortal": "Opening billing portal...",
      "experience": "Experience",
      "usagePercentage": "Usage percentage",
      "creditsAvailable": "Credits available",
      "creditsUsed": "Credits used",
      "creditsInUse": "Credit(s) in use by running tasks",
      "totalCredits": "Total credits",
      "fullNameLabel": "Full name",
      "emailLabel": "Email",
      "displayNameLabel": "Display name",
      "emailDescription": "This is your registered email address",
      "lastUpdatedLabel": "Updated",
      "usageError": "There was an error getting your subscription information or there is no subscription information to display.",
      "emailLabelDescription": "This is your registered email address"
    },
    "auth": {
      "errorHeader": "Authentication Error",
      "retry": "Retry",
      "signInWaitingMessage": "Signing you in",
      "loginCommand": "You need to login to access this page",
      "loginCommandHeader": "Login Required",
      "login": "Login",
      "gettingAccount": "Getting Account",
      "verifyEmail": "Verify Email",
      "resendEmail": "Resend Email",
      "sending": "Sending",
      "verifyEmailDescription": "A link to verify your account has been sent to your email",
      "verifyEmailDescription2": "Check your email and click on the link to verify your account",
      "verificationCountdown": "Email sent. You can request another link in {countdown}",
      "signOut": "Sign-Out",
      "emailVerificationLimitExceeded": "Limit exceeded, please check your email and verify, or try again in {time}"
    },
    "billing": {
      "close": "Close",
      "subscriptionSuccess": "Subscription Success",
      "subscriptionSuccessMessage": "You can start using the app to keep your marketing department one step ahead of the game.",
      "createFirstTask": "Create your first task",
      "freePlanTitle": "Free plan active",
      "freePlanMessage": "You are on the free plan which will expire soon. You can upgrade to a paid plan to increase your usage limits.",
      "exceededTitle": "Usage limit reached",
      "freeTrialTitle": "Free trial expired",
      "trialMessage": "Your free trial ended on {endDate}. Upgrade your plan now to continue accessing all features.",
      "freeTrialExceededMessage": "You have exceeded the free usage limit. Upgrade your plan now to continue accessing all features",
      "exceededMessage": "You have exceeded your usage limit for the current billing period."
    },
    "errors": {
      "tryAgain": "There was an error, please try again",
      "unknown": "Something went wrong",
      "taskFailed": "Sorry, the task failed.",
      "error": "Error"
    },
    "loading": {
      "wait": "Please wait",
      "loadingText": "Loading",
      "gettingTaskTypes": "Please wait while we get the available task types",
      "writingData": "Writing data..."
    },
    "modal": {
      "title": "Confirm",
      "primaryButtonText": "Confirm",
      "secondaryButtonText": "Cancel",
      "message": "Are you sure?"
    },
    "truncatedText": {
      "showLess": "Show less",
      "readMore": "Read more"
    },
    "taskInput": {
      "input": "Input",
      "noInput": "No Input",
      "excluded": "Excluded",
      "startDate": "Start Date",
      "endDate": "End Date"
    },
    "instagram": {
      "likedBy": "Liked by you and 217,247 others"
    },
    "linkedIn": {
      "followers": [
        "No follower",
        " 1 follower",
        "{count} followers"
      ],
      "timePassed": [
        "Os",
        "1s",
        "{count}s"
      ],
      "like": "Like",
      "comment": "Comment",
      "repost": "Repost",
      "share": "Share"
    },
    "twitter": {
      "tag": "tag",
      "GeneratingTweet": "Generating Tweet...",
      "TweetResults": "Tweet results",
      "postTweet": "Post Tweet"
    },
    "taskList": {
      "noTask": "No Recent Content",
      "listInfo": "Explore your recent task outcomes; click any result to see details and start putting your content to work.",
      "recentTaskRunsTitle": "Recent Content",
      "scheduledTaskRunsTitle": "Scheduled Content",
      "scrollToTop": "Scroll To Top",
      "taskType": "Task Type",
      "loadMore": "Load more"
    },
    "newTask": {
      "canCreateTaskMessage": "To run new tasks, you need to upgrade your plan.",
      "usageLimitExceeded": "Usage Limit Exceeded",
      "pleaseWait": "Please wait",
      "upgradePlan": "Upgrade Plan"
    },
    "reviewGoogle": {
      "knowledgeBox": "Knowledge Box",
      "organicResults": "Organic results",
      "relatedQuestions": "Related Questions",
      "relatedSearches": "Related Searches",
      "displayedLinks": "Displayed Links"
    },
    "post": {
      "feedback": "Feedback",
      "qualityScore": "Quality Score",
      "misleadingStatements": "Misleading statements",
      "missingInformation": "Missing Information",
      "passed": "Passed",
      "failed": "Failed",
      "suggestedImprovements": "Suggested Improvements",
      "draft": "Draft",
      "outline": "Outline",
      "final": "Final"
    },
    "subTask": {
      "WritePost": "Writing post",
      "MarketArticleIdentifyKeywords": "Identifying article keywords",
      "MetaContentGeneratorStep1": "Generating Meta content",
      "WriteAllSocialPosts": "Writing posts",
      "Loading": "Loading"
    },
    "marketArticleIdentifyKeywords": {
      "pageContent": "Page Content",
      "keywords": "Keywords",
      "justification": "Reasoning",
      "keyIdeas": "Keyword Ideas",
      "noData": "No Data"
    },
    "feedbackPanel": {
      "title": "Give Feedback",
      "description": "Our product depends on customer feedback to improve the overall experience!",
      "recommendMessage": "How likely would you recommend us to a friend or colleague?",
      "notAtAll": "Not at all",
      "extremelyLikely": "Extremely likely",
      "tellUs": "Tell us in words",
      "leaveFeedback": "Leave a feedback",
      "placeholder": "I really enjoy…"
    },
    "subscriptionContext": {
      "finishingUp": "Finishing up",
      "finishingMessage": "Almost done",
      "promoMessage": "Grab the best tools and take your marketing to the next level",
      "choosePlan": "Choose the Plan for",
      "you": "You"
    },
    "authContext": {
      "almost": "Almost there",
      "almostMessage": "Loading your account"
    },
    "accountSettings": {
      "title": " Online Presence Hub",
      "description": "Manage website and your social accounts in one place.",
      "twitter": "Twitter",
      "facebook": "Facebook",
      "youtube": "Youtube",
      "website": "Website",
      "github": "Github",
      "websiteDescription": "Enter your Website's URL",
      "twitterDescription": "Enter your Twitter account's URL",
      "facebookDescription": "Enter your Facebook account's URL",
      "githubDescription": "Enter your Github account's URL",
      "placeholder": "https://website.com",
      "websites": "Websites"
    },
    "writePost": {
      "feedback": "Feedback",
      "suggestedImprovements": "Suggested improvements",
      "draft": "Draft",
      "outline": "Outline",
      "final": "Final"
    },
    "google": {
      "knowledgeBox": "Knowledge Box",
      "organicResults": "Organic Results",
      "relatedQuestions": "Related Questions",
      "relatedSearches": "Related Searches"
    },
    "reviewWebpage": {
      "DuplicateSections": "Duplicate Sections",
      "GrammarMistakes": "Grammar Mistakes",
      "SpellingIssues": "Spelling Issues",
      "OverallFeedback": "Overall Feedback"
    },
    "initialResearch": {
      "InitialResearch": "Initial Research"
    },
    "metaContentLoading": {
      "TitleTags": "Title Tags",
      "MetaDescriptions": "Meta Descriptions"
    },
    "marketerPickLoading": {
      "Topics": "Topics",
      "Articles": "Articles"
    },
    "WRITE_INSTAGRAM_POST": {
      "name": "Instagram Post",
      "title": "Create Engaging Instagram Content",
      "description": "Auto-create engaging posts with images that captivate on Instagram.",
      "createTask": {
        "sidebarTitle": "Enhance Your Instagram Feed",
        "sidebarDescription": "Enter a description or webpage URL, and receive three unique Instagram posts with matching images. Select your favorites, and share directly to your social network."
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Share Your Story",
            "content": "Copy, paste, and post your new Instagram content to engage followers. For best results, post to your feed 2-3 times weekly."
          }
        ]
      },
      "resultTitle": {
        "running": "Generating image and caption for Instagram...",
        "done": "Instagram post results"
      }
    },
    "WRITE_LINKEDIN_POST": {
      "name": "LinkedIn Post",
      "title": "Generate Professional LinkedIn Posts",
      "description": "Create professional LinkedIn posts that engage and expand your network",
      "createTask": {
        "sidebarTitle": "Grow Your LinkedIn Presence",
        "sidebarDescription": "Input a description or a webpage link, and instantly receive three polished LinkedIn posts with images. Select one or them all and instantly publish to your professional network."
      },
      "resultTitle": {
        "running": "Generating LinkedIn post...",
        "done": "LinkedIn post results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Connect on LinkedIn",
            "content": "Elevate your LinkedIn presence with these posts. A steady stream builds your network."
          }
        ]
      }
    },
    "RUN": {
      "name": "Run Your Marketing Taskforce",
      "title": "Run Your Marketing Taskforce",
      "description": "Activate our full spectrum of marketing tools, from topic research to content generation and social media posting, with one simple input.",
      "createTask": {
        "sidebarTitle": "All-in-One Marketing Generator",
        "sidebarDescription": "Enter a topic or URL to trigger a full suite of marketing tasks. Get everything from in-depth research and content creation to SEO suggestions and social posts, all from a single input."
      },
      "resultTitle": {
        "running": "Running tasks...",
        "done": "Task results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Launch Your Campaign",
            "content": "Leverage this comprehensive output to drive your marketing. Consistent updates keep your audience engaged and content performing better."
          }
        ]
      }
    },
    "WRITE_TWITTER_POST": {
      "name": "Twitter(X) Post",
      "title": "Craft Twitter/X Posts",
      "description": "Turn your ideas into impactful, tweet-ready content in seconds.",
      "createTask": {
        "sidebarTitle": "Amplify Your Twitter Voice",
        "sidebarDescription": "Provide a description or URL, and get three attention-grabbing tweets with visuals. Choose the best fit and post it to your Twitter feed in moments."
      },
      "resultTitle": {
        "running": "Generating Tweet...",
        "done": "Tweet results"
      },
      "tag": "tag",
      "GeneratingTweet": "Generating Tweet...",
      "TweetResults": "Tweet results",
      "postTweet": "Post Tweet",
      "singleTask": {
        "sidebar": [
          {
            "title": "Tweet with Impact",
            "content": "Use these tweets to connect with your audience. Consistent posting drives engagement!"
          }
        ]
      }
    },
    "REVIEW_WEBPAGE": {
      "name": "Review Webpage",
      "title": "Conduct Webpage Analysis",
      "description": "Check your webpage for content issues and get actionable suggestions for improvement.",
      "createTask": {
        "sidebarTitle": "Refine Your Webpage",
        "sidebarDescription": "Submit your webpage URL for an in-depth analysis that checks grammar, spelling, and more. Gain insights and recommendations to elevate your site's content and appeal."
      },
      "resultTitle": {
        "running": "Analyzing the webpage, please wait...",
        "done": "Webpage analysis result"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Apply These Insights",
            "content": "Incorporate these suggestions to improve your webpage. Regular content reviews enhance SEO and user experience."
          }
        ]
      }
    },
    "GENERATE_IMAGE": {
      "name": "Generate Image",
      "title": "Create Custom Images",
      "description": "Receive a custom-designed image that visually amplifies your content.",
      "createTask": {
        "sidebarTitle": "Generate Unique Images",
        "sidebarDescription": "Describe your vision and our tool will craft a custom, copyright-free image for you. Use clear, concise descriptors for best results, and easily integrate the image into your marketing materials"
      },
      "resultTitle": {
        "running": "Generating image...",
        "done": "Image generation result"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Visualize Your Success",
            "content": "Add these images to your marketing content for visual appeal. Images boost engagement and brand recall."
          }
        ]
      }
    },
    "META_CONTENT_GENERATOR": {
      "name": "Generate Meta Content",
      "title": "Generate Meta Content",
      "description": "Automatically generate SEO-friendly title tags and descriptions for your content.",
      "createTask": {
        "sidebarTitle": "Optimize Your Meta Details",
        "sidebarDescription": "Input a topic or URL to receive SEO-optimized meta titles and descriptions. Choose from three variations to best match your page's content and character requirements."
      },
      "resultTitle": {
        "running": "Reviewing and generating meta content...",
        "done": "Meta content results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Maximize Content SEO",
            "content": "Apply these meta tags to boost search visibility. Refreshing meta content boosts SEO."
          }
        ]
      }
    },
    "MARKET_ARTICLE_IDENTIFY_KEYWORDS": {
      "name": "SEO: Identify Keywords",
      "subName": "Keyword Identification",
      "title": "Discover SEO Keywords",
      "description": "Find the best keywords to boost your webpage search engine visibility.",
      "createTask": {
        "sidebarTitle": "Boost SEO with Keywords",
        "sidebarDescription": "Input a webpage URL to uncover the keywords it ranks for and discover additional related search terms. Our tool provides a list of SEO-driven keyword ideas, complete with reasoning to guide your strategy."
      },
      "resultTitle": {
        "running": "Identifying keywords...",
        "done": "Keyword Identification Results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Optimize Using These Keywords",
            "content": "Incorporate these keywords to climb search rankings. Updating keywords keeps content relevant and performing better."
          }
        ]
      }
    },
    "SEARCH_GOOGLE": {
      "name": null,
      "title": null,
      "description": null,
      "createTask": {
        "sidebarTitle": null,
        "sidebarDescription": null
      },
      "resultTitle": {
        "running": "Fetching results from Google...",
        "done": "Google Search results"
      }
    },
    "RESEARCH_V_2": {
      "name": "Activate Research Assistant",
      "subName": "Activate Research Assistant",
      "title": "Activate Research Assistant",
      "description": "Receive concise, actionable research notes on any topic you're exploring.",
      "createTask": {
        "sidebarTitle": "Deep Dive Research",
        "sidebarDescription": "Input a topic or URL for comprehensive research and expert analysis. Receive detailed notes, summaries, and source citations to inform your content creation."
      },
      "resultTitle": {
        "running": "Analyzing input and getting research data...",
        "done": "Research results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Expand Your Knowledge",
            "content": "Use these research notes to inform your content strategy. In-depth knowledge positions you as an expert. "
          }
        ]
      }
    },
    "MARKETER_PICK_TOPICS": {
      "name": "Content Idea Generation",
      "subName": "Content Idea Generation",
      "title": null,
      "description": null,
      "createTask": {
        "sidebarTitle": null,
        "sidebarDescription": null
      },
      "resultTitle": {
        "running": "Running tasks...",
        "done": "Task results"
      }
    },
    "WRITE_ALL_SOCIAL_POSTS": {
      "name": "Write All Social Posts",
      "subName": "Write All Social Posts",
      "title": "Generate Cross-Platform Social Content",
      "description": "Craft unified social media content for LinkedIn, Twitter, Instagram, and Facebook.",
      "createTask": {
        "sidebarTitle": "Optimize Your Social Strategy",
        "sidebarDescription": "Enter your information or a URL, and get a collection of platform-optimized posts. Tailored messaging ensures brand consistency across all your social channels."
      },
      "resultTitle": {
        "running": "Running tasks...",
        "done": "Task results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Boost Your Engagement",
            "content": "Review the optimized content for the specific platform you chose and get ready to engage your followers."
          }
        ]
      }
    },
    "WRITE_POST": {
      "name": "Write Post",
      "subName": "Write Post",
      "title": null,
      "description": null,
      "createTask": {
        "sidebarTitle": null,
        "sidebarDescription": null
      },
      "resultTitle": {
        "running": "Running tasks...",
        "done": "Task results"
      }
    },
    "PREPARE_INITIAL_RESEARCH": {
      "name": "Initial Research",
      "subName": "Early Findings",
      "title": "Refined Research",
      "description": "Detailed Notes and Sources",
      "createTask": {
        "sidebarTitle": "Deep Dive Research",
        "sidebarDescription": "Input a topic or URL for comprehensive research and expert analysis. Receive detailed notes, summaries, and source citations to inform your content creation."
      },
      "resultTitle": {
        "running": "Running tasks...",
        "done": "Task results"
      }
    },
    "META_CONTENT_GENERATOR_STEP_1": {
      "name": "Meta Content Generator",
      "subName": "Meta Content Generator",
      "title": "Generate Meta Content",
      "description": "Automatically generate SEO-friendly title tags and descriptions for your content.",
      "createTask": {
        "sidebarTitle": "Optimize Your Meta Details",
        "sidebarDescription": "Input a topic or URL to receive SEO-optimized meta titles and descriptions. Choose from three variations to best match your page's content and character requirements."
      },
      "resultTitle": {
        "running": "Reviewing and generating meta content...",
        "done": "Meta content results"
      }
    },
    "WRITE_FACEBOOK_POST": {
      "name": "Facebook Post",
      "title": "Create Shareable Facebook Updates",
      "description": "Generate share-worthy Facebook posts that connect with your audience.",
      "createTask": {
        "sidebarTitle": "Update Your Facebook Audience",
        "sidebarDescription": "Input your content details or a URL to generate three engaging Facebook posts with images. Pick the ones that resonate, and share to your Facebook page."
      },
      "resultTitle": {
        "running": "Generating Facebook post...",
        "done": "Facebook Content Results"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Boost Your Engagement",
            "content": "Share these Facebook posts to spark conversations with a simple copy and paste to your page. Regular updates keep your feed lively."
          }
        ]
      }
    },
    "account": {
      "firstName": "First name",
      "lastName": "Last name"
    }
  },
  "es": {
    "wordsOr": "o",
    "wordsUpdateSocialSuccess": "Cuentas sociales actualizadas con éxito",
    "wordsUpdateSocialError": "Error al actualizar cuentas sociales. Por favor, inténtalo de nuevo.",
    "wordsInvalidURL": "URL inválida",
    "wordsInvalidXURL": "URL de perfil de X inválida",
    "wordsInvalidFacebookURL": "URL de perfil de Facebook inválida",
    "wordsMissingXHandle": "Falta el identificador de twitter(X)",
    "wordsMissingFacebookHandle": "Falta el identificador de facebook",
    "wordsDetails": "Detalles",
    "wordsVerified": "Verificado",
    "wordsNotVerified": "No verificado",
    "wordsTaskNotFoundDescription": "Lo sentimos, la tarea que buscabas no se pudo encontrar.",
    "wordsCardImage": "Imagen de tarjeta",
    "wordsUserProfilePicture": "Foto de perfil de usuario",
    "wordsMe": "Yo",
    "profilePicture": "foto de perfil",
    "FailedLogoutMessage": "Error al cerrar sesión, por favor, inténtalo de nuevo.",
    "buttonsSubmit": "Enviar",
    "buttonsBackToList": "Volver a la lista de tareas",
    "buttonContinue": "Continuar",
    "formsDescription": "Descripción",
    "formsAddURL": "Añadir URL",
    "formsAddContent": "Añadir Contenido",
    "formsExceededContentLimit": "Límite de contenido excedido",
    "formsWebsiteUrl": "URL del sitio web",
    "formsHTML": "HTML",
    "formsUrl": "Url",
    "formsHTMLContent": "Contenido HTML",
    "formsAddTopic": "Añadir Tema",
    "formsTopic": "Tema",
    "formsSearchQuery": "Consulta de búsqueda",
    "appPageNotFound": " \"Página no encontrada\"",
    "appPageNotFoundDescription": " \"Lo siento",
    "appClickButtonBelowToGoHome": " \"Haz clic en el botón de abajo para volver a la página de inicio.\"",
    "authDidntGetEmail": "¿No recibiste el correo electrónico?",
    "authResendEmail": "Haz clic aquí para enviar de nuevo",
    "authConfirmedEmail": "¿Confirmaste tu correo electrónico?",
    "billingExceededCreditsAvailable": "Tienes {creditAvailable} créditos disponibles.",
    "success": null,
    "scheduledFor": null,
    "seePendingTasks": null,
    "taskScheduledSuccessMessage": null,
    "thumbsUp": null,
    "thumbsDown": null,
    "regenerate": null,
    "newTaskNewTaskDescription": "Elige una tarea para generar instantáneamente contenido de marketing personalizado. Desde una publicación individual hasta una campaña a gran escala, comienza aquí.",
    "newTaskSingleTasks": "Tareas individuales",
    "newTaskRunNewTask": "Ejecutar una nueva tarea",
    "newTaskCombinedTasks": "Tareas combinadas",
    "newTaskInputHeader": "Adaptado a tu entrada",
    "newTaskInputDescription": "Proporciona temas claros o URLs para la creación de contenido preciso. Las entradas detalladas producen resultados más dirigidos.",
    "newTaskScheduleTask": "Programar tareas futuras",
    "newTaskScheduleTaskDescription": "Configura tareas futuras para la entrega automatizada de contenido. Mantente adelante con material de marketing consistente y oportuno.",
    "newTaskTitle": "Nueva tarea",
    "editTaskTitle": null,
    "PlanYourContentStrategy": "Planifica tu estrategia de contenido",
    "PlanYourContentStrategyMessage": "Mantente proactivo con tu calendario de marketing. Utiliza tus tareas pasadas para informar y programar nuevo contenido.",
    "OptimizeYourContentOutput": "Optimiza tu salida de contenido",
    "OptimizeYourContentOutputMessage": "Examina resultados anteriores para refinar futuras entradas. El asistente de marketing aprende del contenido pasado para mejorar la efectividad.",
    "SwitchtoLightMode": "Cambiar a modo claro",
    "SwitchtoDarkMode": "Cambiar a modo oscuro",
    "IconrepresentingLightMode": "Icono representando el modo claro",
    "IconrepresentingDarkMode": "Icono representando el modo oscuro",
    "TaskList": "Lista de tareas",
    "SwitchbetweenLightandDarkMode": "Cambiar entre modo claro y oscuro",
    "null": null,
    "generatedImage": "imagen generada",
    "errorGettingPlans": " please try again.\"",
    "socialAccountDescription": "Ingresa la URL de tu cuenta de {account}",
    "onboardingSuccessText": "Todo está listo",
    "myCompany": null,
    "canAddCompetitorMessage": " you need to upgrade your plan",
    "noNewTransaction": "Provide a query about your company and let's research and let you know how you rank against your competitors, and your general approval rating on the internet.",
    "emailScheduled": "Add",
    "emailNote": " an email address will be generated. You can send a message to this address to create a task in Marketing Assistant'",
    "facebookNote": null,
    "instagramStep": " then allow all requested permissions.'",
    "linkedInStep": " and you should allow all requested permissions.'",
    "incomingHookDesc": " setup an Incoming Webhook connector and then copy the generated URL and paste it into the Incoming Webhook field.'",
    "outgoingHookDesc": " on the App tab",
    "testNote": " type @YourOutgoingWebhookName(eg. @MaTest) follow by the task command. Teams will post that to the marketing assistant. Upon successful task creation",
    "checkIntegration": "terms accepted",
    "allReadyReview": " post",
    "planUnavailableDescription": null,
    "writeArticle": " creating social media posts",
    "taskProgressStatus": null,
    "contentProgress": " please wait.",
    "mixedMediaWarning": " Twitter or LinkedIn.\"",
    "words": {
      "credits": [
        "sin créditos",
        "crédito",
        "{count} créditos"
      ],
      "task": [
        "sin tareas",
        "tarea",
        "{count} tareas"
      ],
      "copied": "Copiado",
      "noResult": "Sin resultado",
      "noContent": "Sin contenido",
      "preview": "Vista previa",
      "noPost": "Sin publicación",
      "taskNotFound": "Tarea no encontrada",
      "topics": "Temas",
      "articles": "Artículos",
      "titleTags": "Etiquetas de título",
      "metaDescriptions": "Descripciones Meta",
      "initialResearch": "Investigación inicial",
      "notes": "Notas",
      "noNotes": "Sin notas",
      "reviewWebPage": "Revisar página web",
      "home": "inicio",
      "noSocialPost": "Sin publicaciones sociales",
      "person": "Persona",
      "Upgrade": "Mejorar",
      "subTask": "Subtarea"
    },
    "buttons": {
      "cancel": "Cancelar",
      "close": "Cerrar",
      "create": "Crear",
      "delete": "Eliminar",
      "edit": "Editar",
      "loadMore": "Cargar más",
      "next": "Siguiente",
      "save": "Guardar",
      "add": "Añadir",
      "preferredLanguage": "Idioma preferido",
      "select": "Seleccionar",
      "back": "Atrás",
      "postTweet": "Publicar Tweet",
      "createTask": "Crear Tarea",
      "cancelTask": "Cancelar Tarea",
      "getStarted": "Empezar",
      "saveChanges": "Guardar cambios",
      "download": "Descargar",
      "copy": "Copiar",
      "copied": "Copiado"
    },
    "forms": {
      "description": "descripción",
      "url": "url",
      "content": "contenido",
      "addUrl": "añadir url",
      "addContent": "añadir contenido",
      "addDescription": "añadir descripción"
    },
    "settings": {
      "usage": "Uso",
      "settings": "Configuración",
      "myAccount": "Mi cuenta",
      "accountSettings": "Configuración de la cuenta",
      "accountInformation": "Información de la cuenta",
      "billingInformation": "Información de facturación",
      "billingInformationDescription": "Sigue el enlace a continuación para visitar tu portal de facturación seguro. Puedes gestionar tu plan actual y método de pago en el portal.",
      "giveFeedback": "Dar opinión",
      "manageSubscription": "Gestionar suscripción",
      "openingBillingPortal": "Abriendo portal de facturación...",
      "experience": "Experiencia",
      "usagePercentage": "Porcentaje de uso",
      "creditsAvailable": "Créditos disponibles",
      "creditsUsed": "Créditos utilizados",
      "creditsInUse": "Créditos en uso por tareas en ejecución",
      "totalCredits": "Créditos totales",
      "fullNameLabel": "Nombre completo",
      "emailLabel": "Correo electrónico",
      "displayNameLabel": "Nombre de usuario",
      "emailDescription": "Esta es tu dirección de correo electrónico registrada",
      "lastUpdatedLabel": "Actualizado",
      "usageError": "Hubo un error al obtener tu información de suscripción o no hay información de suscripción para mostrar.",
      "emailLabelDescription": "Esta es tu dirección de correo electrónico registrada"
    },
    "auth": {
      "errorHeader": "Error de autenticación",
      "retry": "Reintentar",
      "signInWaitingMessage": "Por favor espera mientras intentamos iniciar sesión",
      "loginCommand": "Necesitas iniciar sesión para acceder a esta página",
      "loginCommandHeader": "Inicio de sesión requerido",
      "login": "Iniciar sesión",
      "gettingAccount": "Obteniendo cuenta",
      "verifyEmail": "Verificar correo electrónico",
      "resendEmail": "Reenviar correo electrónico",
      "sending": "Enviando",
      "verifyEmailDescription": "Se ha enviado un enlace para verificar tu cuenta a tu correo electrónico",
      "verifyEmailDescription2": "Revisa tu correo electrónico y haz clic en el enlace para verificar tu cuenta",
      "verificationCountdown": "Correo electrónico enviado. Puedes solicitar otro enlace en {countdown}",
      "signOut": "Cerrar sesión",
      "emailVerificationLimitExceeded": "Límite excedido, por favor verifica tu correo electrónico y verifica, o inténtalo de nuevo en {time}"
    },
    "billing": {
      "close": "Cerrar",
      "subscriptionSuccess": "Éxito en la suscripción",
      "subscriptionSuccessMessage": "Puedes empezar a usar la aplicación para mantener a tu departamento de marketing un paso adelante.",
      "createFirstTask": "Crea tu primera tarea",
      "freePlanTitle": "Plan gratuito activo",
      "freePlanMessage": "Estás en el plan gratuito que expirará pronto. Puedes actualizar a un plan de pago para aumentar tus límites de uso.",
      "exceededTitle": "Límite de uso alcanzado",
      "freeTrialTitle": "Prueba gratuita expirada",
      "trialMessage": "Has excedido el límite de uso gratuito. Por favor, actualiza tu plan.",
      "exceededMessage": "Has excedido tu límite de uso para el período de facturación actual."
    },
    "errors": {
      "tryAgain": "Hubo un error, por favor intenta de nuevo",
      "unknown": "Algo salió mal",
      "taskFailed": "Lo siento, la tarea falló. Revisa tus indicaciones y vuelve a intentarlo.",
      "error": "Error"
    },
    "loading": {
      "wait": "Por favor espera",
      "loadingText": "Cargando",
      "gettingTaskTypes": "Por favor espera mientras obtenemos los tipos de tareas disponibles"
    },
    "modal": {
      "title": "Confirmar",
      "primaryButtonText": "Confirmar",
      "secondaryButtonText": "Cancelar",
      "message": "¿Estás seguro?"
    },
    "truncatedText": {
      "showLess": "Mostrar menos",
      "readMore": "Leer más"
    },
    "taskInput": {
      "input": "Entrada",
      "noInput": "Sin entrada",
      "excluded": "Excluido",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha de fin"
    },
    "instagram": {
      "likedBy": "Te gusta a ti y a otros 217,247"
    },
    "linkedIn": {
      "followers": [
        "Sin seguidor",
        " 1 seguidor",
        "{count} seguidores"
      ],
      "timePassed": [
        "Os",
        "1s",
        "{count}s"
      ],
      "like": "Me gusta",
      "comment": "Comentar",
      "repost": "Repostear",
      "share": "Compartir"
    },
    "twitter": {
      "tag": "etiqueta",
      "GeneratingTweet": "Generando Tweet...",
      "TweetResults": "Resultados del Tweet",
      "postTweet": "Publicar Tweet"
    },
    "taskList": {
      "noTask": "Sin tareas recientes",
      "listInfo": "Explora los resultados de tus tareas recientes; haz clic en cualquier resultado para ver detalles y comenzar a utilizar tu contenido.",
      "recentTaskRunsTitle": "Tareas recientes",
      "scrollToTop": "Desplazarse hacia arriba",
      "taskType": "Tipo de tarea",
      "loadMore": "Cargar más"
    },
    "newTask": {
      "canCreateTaskMessage": "Para ejecutar nuevas tareas, necesitas actualizar tu plan.",
      "usageLimitExceeded": "Límite de uso excedido",
      "pleaseWait": "Por favor espera",
      "upgradePlan": "Actualizar plan"
    },
    "reviewGoogle": {
      "knowledgeBox": "Caja de conocimiento",
      "organicResults": "Resultados orgánicos",
      "relatedQuestions": "Preguntas relacionadas",
      "relatedSearches": "Búsquedas relacionadas",
      "displayedLinks": "Enlaces mostrados"
    },
    "post": {
      "feedback": "Retroalimentación",
      "qualityScore": "Puntuación de calidad",
      "misleadingStatements": "Declaraciones engañosas",
      "missingInformation": "Información faltante",
      "passed": "Aprobado",
      "failed": "Fallado",
      "suggestedImprovements": "Mejoras sugeridas",
      "draft": "Borrador",
      "outline": "Esquema",
      "final": "Final"
    },
    "subTask": {
      "WritePost": "Escribiendo publicación",
      "MarketArticleIdentifyKeywords": "Identificando palabras clave de artículo",
      "MetaContentGeneratorStep1": "Generando contenido Meta",
      "WriteAllSocialPosts": "Escribiendo publicaciones",
      "Loading": "Cargando"
    },
    "marketArticleIdentifyKeywords": {
      "pageContent": "Contenido de la página",
      "keywords": "Palabras clave",
      "justification": "Justificación",
      "keyIdeas": "Ideas de palabras clave",
      "noData": "Sin datos"
    },
    "feedbackPanel": {
      "title": "Dar opinión",
      "description": "¡Nuestro producto depende de la retroalimentación del cliente para mejorar la experiencia general!",
      "recommendMessage": "¿Qué tan probable es que nos recomiendes a un amigo o colega?",
      "notAtAll": "Nada probable",
      "extremelyLikely": "Extremadamente probable",
      "tellUs": "Dinos en palabras",
      "leaveFeedback": "Dejar una opinión",
      "placeholder": "Realmente disfruto..."
    },
    "subscriptionContext": {
      "finishingUp": "Terminando",
      "finishingMessage": "Esto solo debería tomar unos segundos, por favor ten paciencia",
      "promoMessage": "Obtén las mejores herramientas y lleva tu marketing al siguiente nivel",
      "choosePlan": "Elige el plan para",
      "you": "ti"
    },
    "authContext": {
      "almost": "Casi allí",
      "almostMessage": "Por favor espera mientras preparamos la aplicación para ti"
    },
    "accountSettings": {
      "title": " Centro de presencia en línea",
      "description": "Gestiona tu sitio web y tus cuentas sociales en un solo lugar.",
      "twitter": "Twitter",
      "facebook": "Facebook",
      "youtube": "Youtube",
      "website": "Sitio web",
      "github": "Github",
      "websiteDescription": "Ingresa la URL de tu sitio web",
      "twitterDescription": "Ingresa la URL de tu cuenta de Twitter",
      "facebookDescription": "Ingresa la URL de tu cuenta de Facebook",
      "githubDescription": "Ingresa la URL de tu cuenta de Github",
      "placeholder": "https://website.com"
    },
    "writePost": {
      "feedback": "Retroalimentación",
      "suggestedImprovements": "Mejoras sugeridas",
      "draft": "Borrador",
      "outline": "Esquema",
      "final": "Final"
    },
    "google": {
      "knowledgeBox": "Caja de conocimiento",
      "organicResults": "Resultados orgánicos",
      "relatedQuestions": "Preguntas relacionadas",
      "relatedSearches": "Búsquedas relacionadas"
    },
    "reviewWebpage": {
      "DuplicateSections": "Secciones duplicadas",
      "GrammarMistakes": "Errores gramaticales",
      "SpellingIssues": "Problemas de ortografía",
      "OverallFeedback": "Retroalimentación general"
    },
    "initialResearch": {
      "InitialResearch": "Investigación inicial"
    },
    "metaContentLoading": {
      "TitleTags": "Etiquetas de título",
      "MetaDescriptions": "Descripciones Meta"
    },
    "marketerPickLoading": {
      "Topics": "Temas",
      "Articles": "Artículos"
    },
    "WRITE_INSTAGRAM_POST": {
      "name": "Publicación en Instagram",
      "title": "Crear contenido atractivo para Instagram",
      "description": "Auto-crear publicaciones atractivas con imágenes que cautiven en Instagram.",
      "createTask": {
        "sidebarTitle": "Mejora tu feed de Instagram",
        "sidebarDescription": "Ingresa una descripción o URL de una página web, y recibe tres publicaciones únicas de Instagram con imágenes correspondientes. Selecciona tus favoritas y comparte directamente en tu red social."
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Comparte tu historia",
            "content": "Copia, pega y publica tu nuevo contenido de Instagram para involucrar a los seguidores. Para obtener mejores resultados, publica en tu feed de 2 a 3 veces por semana."
          }
        ]
      },
      "resultTitle": {
        "running": "Generando imagen y subtítulo para Instagram...",
        "done": "Resultados de la publicación en Instagram"
      }
    },
    "WRITE_LINKEDIN_POST": {
      "name": "Publicación en LinkedIn",
      "title": "Generar publicaciones profesionales en LinkedIn",
      "description": "Crea publicaciones profesionales en LinkedIn que involucren y expandan tu red",
      "createTask": {
        "sidebarTitle": "Crecer tu presencia en LinkedIn",
        "sidebarDescription": "Ingresa una descripción o un enlace de página web, y recibe instantáneamente tres publicaciones pulidas de LinkedIn con imágenes. Selecciona una o todas y publica instantáneamente en tu red profesional."
      },
      "resultTitle": {
        "running": "Generando publicación en LinkedIn...",
        "done": "Resultados de la publicación en LinkedIn"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Conectar en LinkedIn",
            "content": "Eleva tu presencia en LinkedIn con estas publicaciones. Una secuencia constante construye tu red."
          }
        ]
      }
    },
    "RUN": {
      "name": "Ejecuta tu fuerza de tarea de marketing",
      "title": "Ejecuta tu fuerza de tarea de marketing",
      "description": "Activa nuestro espectro completo de herramientas de marketing, desde investigación de temas hasta generación de contenido y publicación en redes sociales, con una simple entrada.",
      "createTask": {
        "sidebarTitle": "Generador de marketing todo en uno",
        "sidebarDescription": "Ingresa un tema o URL para activar una suite completa de tareas de marketing. Obtén todo, desde investigación en profundidad y creación de contenido hasta sugerencias de SEO y publicaciones sociales, todo a partir de una sola entrada."
      },
      "resultTitle": {
        "running": "Ejecutando tareas...",
        "done": "Resultados de las tareas"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Lanza tu campaña",
            "content": "Aprovecha esta salida integral para impulsar tu marketing. Las actualizaciones consistentes mantienen a tu audiencia involucrada y el contenido rindiendo mejor."
          }
        ]
      }
    },
    "WRITE_TWITTER_POST": {
      "name": "Publicación en Twitter(X)",
      "title": "Crear publicaciones para Twitter/X",
      "description": "Convierte tus ideas en contenido impactante y listo para tweet en segundos.",
      "createTask": {
        "sidebarTitle": "Amplifica tu voz en Twitter",
        "sidebarDescription": "Proporciona una descripción o URL, y obtén tres tweets llamativos con visuales. Elige el mejor ajuste y publícalo en tu feed de Twitter en momentos."
      },
      "resultTitle": {
        "running": "Generando Tweet...",
        "done": "Resultados del Tweet"
      },
      "tag": "etiqueta",
      "GeneratingTweet": "Generando Tweet...",
      "TweetResults": "Resultados del Tweet",
      "postTweet": "Publicar Tweet",
      "singleTask": {
        "sidebar": [
          {
            "title": "Tweet con impacto",
            "content": "Usa estos tweets para conectar con tu audiencia. La publicación constante impulsa la participación!"
          }
        ]
      }
    },
    "REVIEW_WEBPAGE": {
      "name": "Revisar página web",
      "title": "Realizar análisis de página web",
      "description": "Revisa tu página web en busca de problemas de contenido y obtén sugerencias de acción para mejorar.",
      "createTask": {
        "sidebarTitle": "Refina tu página web",
        "sidebarDescription": "Envía la URL de tu página web para un análisis en profundidad que verifica gramática, ortografía y más. Obtén perspectivas y recomendaciones para elevar el contenido y el atractivo de tu sitio."
      },
      "resultTitle": {
        "running": "Analizando la página web, por favor espera...",
        "done": "Resultado del análisis de la página web"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Aplica estos conocimientos",
            "content": "Incorpora estas sugerencias para mejorar tu página web. Revisiones regulares de contenido mejoran el SEO y la experiencia del usuario."
          }
        ]
      }
    },
    "GENERATE_IMAGE": {
      "name": "Generar imagen",
      "title": "Crear imágenes personalizadas",
      "description": "Recibe una imagen diseñada a medida que amplifica visualmente tu contenido.",
      "createTask": {
        "sidebarTitle": "Generar imágenes únicas",
        "sidebarDescription": "Describe tu visión o ingresa una URL, y nuestra herramienta creará una imagen personalizada y libre de derechos de autor para ti. Usa descriptores claros y concisos para obtener mejores resultados, e integra fácilmente la imagen en tus materiales de marketing"
      },
      "resultTitle": {
        "running": "Generando imagen...",
        "done": "Resultado de la generación de imagen"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Visualiza tu éxito",
            "content": "Añade estas imágenes a tu contenido de marketing para atractivo visual. Las imágenes aumentan la participación y el recuerdo."
          }
        ]
      }
    },
    "META_CONTENT_GENERATOR": {
      "name": "Generar contenido Meta",
      "title": "Generar contenido Meta",
      "description": "Genera automáticamente etiquetas de título y descripciones amigables con SEO para tu contenido.",
      "createTask": {
        "sidebarTitle": "Optimiza tus detalles Meta",
        "sidebarDescription": "Ingresa un tema o URL para recibir títulos meta y descripciones optimizadas para SEO. Elige entre tres variaciones para que coincidan mejor con el contenido de tu página y los requisitos de caracteres."
      },
      "resultTitle": {
        "running": "Revisando y generando contenido meta...",
        "done": "Resultados del contenido meta"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Maximiza el SEO de contenido",
            "content": "Aplica estas etiquetas meta para impulsar la visibilidad en la búsqueda. Refrescar el contenido meta ayuda al SEO."
          }
        ]
      }
    },
    "MARKET_ARTICLE_IDENTIFY_KEYWORDS": {
      "name": "SEO: Identificar palabras clave",
      "subName": "Artículo de mercado Identificar palabras clave",
      "title": "Descubrir palabras clave SEO",
      "description": "Encuentra las mejores palabras clave para impulsar la visibilidad de tu página web en los motores de búsqueda.",
      "createTask": {
        "sidebarTitle": "Impulsa el SEO con palabras clave",
        "sidebarDescription": "Ingresa la URL de una página web para descubrir las palabras clave para las que se clasifica y descubre términos de búsqueda relacionados adicionales. Nuestra herramienta proporciona una lista de ideas de palabras clave impulsadas por SEO, completa con razonamiento para guiar tu estrategia."
      },
      "resultTitle": {
        "running": "Identificando palabras clave...",
        "done": "Resultados de la identificación de palabras clave"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Optimiza usando estas palabras clave",
            "content": "Incorpora estas palabras clave para escalar en los rankings de búsqueda. Actualizar las palabras clave mantiene el contenido relevante y con mejor rendimiento."
          }
        ]
      }
    },
    "SEARCH_GOOGLE": {
      "name": null,
      "title": null,
      "description": null,
      "createTask": {
        "sidebarTitle": null,
        "sidebarDescription": null
      },
      "resultTitle": {
        "running": "Obteniendo resultados de Google...",
        "done": "Resultados de la búsqueda de Google"
      }
    },
    "RESEARCH_V_2": {
      "name": "Investigación V 2",
      "subName": "Investigación V 2",
      "title": "Activar asistente de investigación",
      "description": "Recibe notas concisas y accionables sobre cualquier tema que estés explorando.",
      "createTask": {
        "sidebarTitle": "Investigación profunda",
        "sidebarDescription": "Ingresa un tema o URL para una investigación completa y un análisis experto. Recibe notas detalladas, resúmenes y citas de fuentes para informar tu creación de contenido."
      },
      "resultTitle": {
        "running": "Analizando la entrada y obteniendo datos de investigación...",
        "done": "Resultados de la investigación"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": null,
            "content": null
          }
        ]
      }
    },
    "MARKETER_PICK_TOPICS": {
      "name": "Temas seleccionados por el comercializador",
      "subName": "Temas seleccionados por el comercializador",
      "title": null,
      "description": null,
      "createTask": {
        "sidebarTitle": null,
        "sidebarDescription": null
      },
      "resultTitle": {
        "running": "Ejecutando tareas...",
        "done": "Resultados de las tareas"
      }
    },
    "WRITE_ALL_SOCIAL_POSTS": {
      "name": "Escribir todas las publicaciones sociales",
      "subName": "Escribir todas las publicaciones sociales",
      "title": "Generar contenido social multiplataforma",
      "description": "Crea contenido unificado para redes sociales para LinkedIn, Twitter, Instagram y Facebook.",
      "createTask": {
        "sidebarTitle": "Optimiza tu estrategia social",
        "sidebarDescription": "Ingresa tu información o una URL, y obtén una colección de publicaciones optimizadas para la plataforma. Mensajes a medida aseguran la consistencia de la marca en todos tus canales sociales."
      },
      "resultTitle": {
        "running": "Ejecutando tareas...",
        "done": "Resultados de las tareas"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Impulsa tu participación",
            "content": "Revisa el contenido optimizado para la plataforma específica que elegiste y prepárate para involucrar a tus seguidores."
          }
        ]
      }
    },
    "WRITE_POST": {
      "name": "Escribir publicación",
      "subName": "Escribir publicación",
      "title": null,
      "description": null,
      "createTask": {
        "sidebarTitle": null,
        "sidebarDescription": null
      },
      "resultTitle": {
        "running": "Ejecutando tareas...",
        "done": "Resultados de las tareas"
      }
    },
    "PREPARE_INITIAL_RESEARCH": {
      "name": "Preparar investigación inicial",
      "subName": "Preparar investigación inicial",
      "title": "Activar asistente de investigación",
      "description": "Recibe notas concisas y accionables sobre cualquier tema que estés explorando.",
      "createTask": {
        "sidebarTitle": "Investigación profunda",
        "sidebarDescription": "Ingresa un tema o URL para una investigación completa y un análisis experto. Recibe notas detalladas, resúmenes y citas de fuentes para informar tu creación de contenido."
      },
      "resultTitle": {
        "running": "Ejecutando tareas...",
        "done": "Resultados de las tareas"
      }
    },
    "META_CONTENT_GENERATOR_STEP_1": {
      "name": "Generador de contenido Meta",
      "subName": "Generador de contenido Meta",
      "title": "Generar contenido Meta",
      "description": "Genera automáticamente etiquetas de título y descripciones amigables con SEO para tu contenido.",
      "createTask": {
        "sidebarTitle": "Optimiza tus detalles Meta",
        "sidebarDescription": "Ingresa un tema o URL para recibir títulos meta y descripciones optimizadas para SEO. Elige entre tres variaciones para que coincidan mejor con el contenido de tu página y los requisitos de caracteres."
      },
      "resultTitle": {
        "running": "Revisando y generando contenido meta...",
        "done": "Resultados del contenido meta"
      }
    },
    "WRITE_FACEBOOK_POST": {
      "name": "Publicación en Facebook",
      "title": "Crear actualizaciones compartibles en Facebook",
      "description": "Genera publicaciones en Facebook dignas de compartir que conecten con tu audiencia.",
      "createTask": {
        "sidebarTitle": "Actualizar a tu audiencia de Facebook",
        "sidebarDescription": "Ingresa los detalles de tu contenido o una URL para generar tres publicaciones atractivas en Facebook con imágenes. Elige las que resuenen y comparte en tu página de Facebook sin problemas."
      },
      "resultTitle": {
        "running": "Generando publicación en Facebook...",
        "done": "Resultados del contenido de Facebook"
      },
      "singleTask": {
        "sidebar": [
          {
            "title": "Impulsa tu participación",
            "content": "Comparte estas publicaciones en Facebook para iniciar conversaciones con un simple copiar y pegar en tu página. Las actualizaciones regulares mantienen tu feed animado."
          }
        ]
      }
    },
    "account": {}
  }
};